//# sourceMappingURL=ai_config.mjs.map
/// <reference types="./ai_config.d.mts" />
import * as $json from "../../gleam_json/gleam/json.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $float from "../../gleam_stdlib/gleam/float.mjs";
import * as $int from "../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import * as $weaviate from "../data/weaviate.mjs";
import * as $decrypt from "../decrypt.mjs";
import { Ok, toList, CustomType as $CustomType } from "../gleam.mjs";

export class Hybrid extends $CustomType {}
export const RetrieverOptionType$Hybrid = () => new Hybrid();
export const RetrieverOptionType$isHybrid = (value) => value instanceof Hybrid;

export class Rerank extends $CustomType {}
export const RetrieverOptionType$Rerank = () => new Rerank();
export const RetrieverOptionType$isRerank = (value) => value instanceof Rerank;

export class Fusion extends $CustomType {}
export const RetrieverOptionType$Fusion = () => new Fusion();
export const RetrieverOptionType$isFusion = (value) => value instanceof Fusion;

export class RoleOff extends $CustomType {}
export const Role$RoleOff = () => new RoleOff();
export const Role$isRoleOff = (value) => value instanceof RoleOff;

export class RoleRfpExpert extends $CustomType {}
export const Role$RoleRfpExpert = () => new RoleRfpExpert();
export const Role$isRoleRfpExpert = (value) => value instanceof RoleRfpExpert;

export class EntityMismatchOff extends $CustomType {}
export const EntityMismatch$EntityMismatchOff = () => new EntityMismatchOff();
export const EntityMismatch$isEntityMismatchOff = (value) =>
  value instanceof EntityMismatchOff;

export class EntityMismatchDefault extends $CustomType {}
export const EntityMismatch$EntityMismatchDefault = () =>
  new EntityMismatchDefault();
export const EntityMismatch$isEntityMismatchDefault = (value) =>
  value instanceof EntityMismatchDefault;

export class ApproachOff extends $CustomType {}
export const Approach$ApproachOff = () => new ApproachOff();
export const Approach$isApproachOff = (value) => value instanceof ApproachOff;

export class ApproachDefault extends $CustomType {}
export const Approach$ApproachDefault = () => new ApproachDefault();
export const Approach$isApproachDefault = (value) =>
  value instanceof ApproachDefault;

export class ToneStyleOff extends $CustomType {}
export const ToneStyle$ToneStyleOff = () => new ToneStyleOff();
export const ToneStyle$isToneStyleOff = (value) =>
  value instanceof ToneStyleOff;

export class ToneStyleDefault extends $CustomType {}
export const ToneStyle$ToneStyleDefault = () => new ToneStyleDefault();
export const ToneStyle$isToneStyleDefault = (value) =>
  value instanceof ToneStyleDefault;

export class FormattingOff extends $CustomType {}
export const Formatting$FormattingOff = () => new FormattingOff();
export const Formatting$isFormattingOff = (value) =>
  value instanceof FormattingOff;

export class FormattingDefault extends $CustomType {}
export const Formatting$FormattingDefault = () => new FormattingDefault();
export const Formatting$isFormattingDefault = (value) =>
  value instanceof FormattingDefault;

export class EvidenceOverAssertionOff extends $CustomType {}
export const EvidenceOverAssertion$EvidenceOverAssertionOff = () =>
  new EvidenceOverAssertionOff();
export const EvidenceOverAssertion$isEvidenceOverAssertionOff = (value) =>
  value instanceof EvidenceOverAssertionOff;

export class EvidenceOverAssertionDefault extends $CustomType {}
export const EvidenceOverAssertion$EvidenceOverAssertionDefault = () =>
  new EvidenceOverAssertionDefault();
export const EvidenceOverAssertion$isEvidenceOverAssertionDefault = (value) =>
  value instanceof EvidenceOverAssertionDefault;

export class RedirectOff extends $CustomType {}
export const Redirect$RedirectOff = () => new RedirectOff();
export const Redirect$isRedirectOff = (value) => value instanceof RedirectOff;

export class RedirectDefault extends $CustomType {}
export const Redirect$RedirectDefault = () => new RedirectDefault();
export const Redirect$isRedirectDefault = (value) =>
  value instanceof RedirectDefault;

export class ToneVoiceOff extends $CustomType {}
export const ToneVoice$ToneVoiceOff = () => new ToneVoiceOff();
export const ToneVoice$isToneVoiceOff = (value) =>
  value instanceof ToneVoiceOff;

export class ToneVoiceCustomer extends $CustomType {}
export const ToneVoice$ToneVoiceCustomer = () => new ToneVoiceCustomer();
export const ToneVoice$isToneVoiceCustomer = (value) =>
  value instanceof ToneVoiceCustomer;

export class ToneVoiceEngaged extends $CustomType {}
export const ToneVoice$ToneVoiceEngaged = () => new ToneVoiceEngaged();
export const ToneVoice$isToneVoiceEngaged = (value) =>
  value instanceof ToneVoiceEngaged;

export class ToneVoiceGeneric extends $CustomType {}
export const ToneVoice$ToneVoiceGeneric = () => new ToneVoiceGeneric();
export const ToneVoice$isToneVoiceGeneric = (value) =>
  value instanceof ToneVoiceGeneric;

export class RepeatQuestionOff extends $CustomType {}
export const RepeatQuestion$RepeatQuestionOff = () => new RepeatQuestionOff();
export const RepeatQuestion$isRepeatQuestionOff = (value) =>
  value instanceof RepeatQuestionOff;

export class Repeat extends $CustomType {}
export const RepeatQuestion$Repeat = () => new Repeat();
export const RepeatQuestion$isRepeat = (value) => value instanceof Repeat;

export class DoNotRepeat extends $CustomType {}
export const RepeatQuestion$DoNotRepeat = () => new DoNotRepeat();
export const RepeatQuestion$isDoNotRepeat = (value) =>
  value instanceof DoNotRepeat;

export class DoNotRepeatWarm extends $CustomType {}
export const RepeatQuestion$DoNotRepeatWarm = () => new DoNotRepeatWarm();
export const RepeatQuestion$isDoNotRepeatWarm = (value) =>
  value instanceof DoNotRepeatWarm;

export class LengthRuleOff extends $CustomType {}
export const LengthRule$LengthRuleOff = () => new LengthRuleOff();
export const LengthRule$isLengthRuleOff = (value) =>
  value instanceof LengthRuleOff;

export class CategoryBased extends $CustomType {}
export const LengthRule$CategoryBased = () => new CategoryBased();
export const LengthRule$isCategoryBased = (value) =>
  value instanceof CategoryBased;

export class Generalistic extends $CustomType {}
export const LengthRule$Generalistic = () => new Generalistic();
export const LengthRule$isGeneralistic = (value) =>
  value instanceof Generalistic;

export class WhatToReturnOff extends $CustomType {}
export const WhatToReturn$WhatToReturnOff = () => new WhatToReturnOff();
export const WhatToReturn$isWhatToReturnOff = (value) =>
  value instanceof WhatToReturnOff;

export class ReturnJson extends $CustomType {}
export const WhatToReturn$ReturnJson = () => new ReturnJson();
export const WhatToReturn$isReturnJson = (value) => value instanceof ReturnJson;

export class ReturnText extends $CustomType {}
export const WhatToReturn$ReturnText = () => new ReturnText();
export const WhatToReturn$isReturnText = (value) => value instanceof ReturnText;

export class RagModularConfig extends $CustomType {
  constructor(role, entity_mismatch, approach, tone_voice, tone_style, repeat_or_not_question, formatting, length, evidence_over_assertion, redirect, what_to_return) {
    super();
    this.role = role;
    this.entity_mismatch = entity_mismatch;
    this.approach = approach;
    this.tone_voice = tone_voice;
    this.tone_style = tone_style;
    this.repeat_or_not_question = repeat_or_not_question;
    this.formatting = formatting;
    this.length = length;
    this.evidence_over_assertion = evidence_over_assertion;
    this.redirect = redirect;
    this.what_to_return = what_to_return;
  }
}
export const RagModularConfig$RagModularConfig = (role, entity_mismatch, approach, tone_voice, tone_style, repeat_or_not_question, formatting, length, evidence_over_assertion, redirect, what_to_return) =>
  new RagModularConfig(role,
  entity_mismatch,
  approach,
  tone_voice,
  tone_style,
  repeat_or_not_question,
  formatting,
  length,
  evidence_over_assertion,
  redirect,
  what_to_return);
export const RagModularConfig$isRagModularConfig = (value) =>
  value instanceof RagModularConfig;
export const RagModularConfig$RagModularConfig$role = (value) => value.role;
export const RagModularConfig$RagModularConfig$0 = (value) => value.role;
export const RagModularConfig$RagModularConfig$entity_mismatch = (value) =>
  value.entity_mismatch;
export const RagModularConfig$RagModularConfig$1 = (value) =>
  value.entity_mismatch;
export const RagModularConfig$RagModularConfig$approach = (value) =>
  value.approach;
export const RagModularConfig$RagModularConfig$2 = (value) => value.approach;
export const RagModularConfig$RagModularConfig$tone_voice = (value) =>
  value.tone_voice;
export const RagModularConfig$RagModularConfig$3 = (value) => value.tone_voice;
export const RagModularConfig$RagModularConfig$tone_style = (value) =>
  value.tone_style;
export const RagModularConfig$RagModularConfig$4 = (value) => value.tone_style;
export const RagModularConfig$RagModularConfig$repeat_or_not_question = (value) =>
  value.repeat_or_not_question;
export const RagModularConfig$RagModularConfig$5 = (value) =>
  value.repeat_or_not_question;
export const RagModularConfig$RagModularConfig$formatting = (value) =>
  value.formatting;
export const RagModularConfig$RagModularConfig$6 = (value) => value.formatting;
export const RagModularConfig$RagModularConfig$length = (value) => value.length;
export const RagModularConfig$RagModularConfig$7 = (value) => value.length;
export const RagModularConfig$RagModularConfig$evidence_over_assertion = (value) =>
  value.evidence_over_assertion;
export const RagModularConfig$RagModularConfig$8 = (value) =>
  value.evidence_over_assertion;
export const RagModularConfig$RagModularConfig$redirect = (value) =>
  value.redirect;
export const RagModularConfig$RagModularConfig$9 = (value) => value.redirect;
export const RagModularConfig$RagModularConfig$what_to_return = (value) =>
  value.what_to_return;
export const RagModularConfig$RagModularConfig$10 = (value) =>
  value.what_to_return;

export class OpenAi extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const ModelType$OpenAi = ($0) => new OpenAi($0);
export const ModelType$isOpenAi = (value) => value instanceof OpenAi;
export const ModelType$OpenAi$0 = (value) => value[0];

export class AzureOpenAi extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const ModelType$AzureOpenAi = ($0) => new AzureOpenAi($0);
export const ModelType$isAzureOpenAi = (value) => value instanceof AzureOpenAi;
export const ModelType$AzureOpenAi$0 = (value) => value[0];

export class AzureAi extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const ModelType$AzureAi = ($0) => new AzureAi($0);
export const ModelType$isAzureAi = (value) => value instanceof AzureAi;
export const ModelType$AzureAi$0 = (value) => value[0];

export class Anthropic extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const ModelType$Anthropic = ($0) => new Anthropic($0);
export const ModelType$isAnthropic = (value) => value instanceof Anthropic;
export const ModelType$Anthropic$0 = (value) => value[0];

export class Bedrock extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const ModelType$Bedrock = ($0) => new Bedrock($0);
export const ModelType$isBedrock = (value) => value instanceof Bedrock;
export const ModelType$Bedrock$0 = (value) => value[0];

export class Gemini extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const ModelType$Gemini = ($0) => new Gemini($0);
export const ModelType$isGemini = (value) => value instanceof Gemini;
export const ModelType$Gemini$0 = (value) => value[0];

export class AzureGpt4o extends $CustomType {}
export const AzureOpenAiModel$AzureGpt4o = () => new AzureGpt4o();
export const AzureOpenAiModel$isAzureGpt4o = (value) =>
  value instanceof AzureGpt4o;

export class AzureGpt41Mini extends $CustomType {}
export const AzureOpenAiModel$AzureGpt41Mini = () => new AzureGpt41Mini();
export const AzureOpenAiModel$isAzureGpt41Mini = (value) =>
  value instanceof AzureGpt41Mini;

export class AzureGpt5Chat extends $CustomType {}
export const AzureAiModel$AzureGpt5Chat = () => new AzureGpt5Chat();
export const AzureAiModel$isAzureGpt5Chat = (value) =>
  value instanceof AzureGpt5Chat;

export class AzureGpt51Chat extends $CustomType {}
export const AzureAiModel$AzureGpt51Chat = () => new AzureGpt51Chat();
export const AzureAiModel$isAzureGpt51Chat = (value) =>
  value instanceof AzureGpt51Chat;

export class AzureGpt5Nano extends $CustomType {}
export const AzureAiModel$AzureGpt5Nano = () => new AzureGpt5Nano();
export const AzureAiModel$isAzureGpt5Nano = (value) =>
  value instanceof AzureGpt5Nano;

export class AzureLlama4Scout extends $CustomType {}
export const AzureAiModel$AzureLlama4Scout = () => new AzureLlama4Scout();
export const AzureAiModel$isAzureLlama4Scout = (value) =>
  value instanceof AzureLlama4Scout;

export class Gpt4o extends $CustomType {}
export const OpenAiModel$Gpt4o = () => new Gpt4o();
export const OpenAiModel$isGpt4o = (value) => value instanceof Gpt4o;

export class Gpt41Nano extends $CustomType {}
export const OpenAiModel$Gpt41Nano = () => new Gpt41Nano();
export const OpenAiModel$isGpt41Nano = (value) => value instanceof Gpt41Nano;

export class Gpt41Mini extends $CustomType {}
export const OpenAiModel$Gpt41Mini = () => new Gpt41Mini();
export const OpenAiModel$isGpt41Mini = (value) => value instanceof Gpt41Mini;

export class Gpt41 extends $CustomType {}
export const OpenAiModel$Gpt41 = () => new Gpt41();
export const OpenAiModel$isGpt41 = (value) => value instanceof Gpt41;

export class Gpt5Nano extends $CustomType {}
export const OpenAiModel$Gpt5Nano = () => new Gpt5Nano();
export const OpenAiModel$isGpt5Nano = (value) => value instanceof Gpt5Nano;

export class Gpt5Mini extends $CustomType {}
export const OpenAiModel$Gpt5Mini = () => new Gpt5Mini();
export const OpenAiModel$isGpt5Mini = (value) => value instanceof Gpt5Mini;

export class Gpt5 extends $CustomType {}
export const OpenAiModel$Gpt5 = () => new Gpt5();
export const OpenAiModel$isGpt5 = (value) => value instanceof Gpt5;

export class Gpt5ChatLatest extends $CustomType {}
export const OpenAiModel$Gpt5ChatLatest = () => new Gpt5ChatLatest();
export const OpenAiModel$isGpt5ChatLatest = (value) =>
  value instanceof Gpt5ChatLatest;

export class Gpt51 extends $CustomType {}
export const OpenAiModel$Gpt51 = () => new Gpt51();
export const OpenAiModel$isGpt51 = (value) => value instanceof Gpt51;

export class Gpt51ChatLatest extends $CustomType {}
export const OpenAiModel$Gpt51ChatLatest = () => new Gpt51ChatLatest();
export const OpenAiModel$isGpt51ChatLatest = (value) =>
  value instanceof Gpt51ChatLatest;

export class Gpt52 extends $CustomType {}
export const OpenAiModel$Gpt52 = () => new Gpt52();
export const OpenAiModel$isGpt52 = (value) => value instanceof Gpt52;

export class Gpt52ChatLatest extends $CustomType {}
export const OpenAiModel$Gpt52ChatLatest = () => new Gpt52ChatLatest();
export const OpenAiModel$isGpt52ChatLatest = (value) =>
  value instanceof Gpt52ChatLatest;

export class Gpt54Nano extends $CustomType {}
export const OpenAiModel$Gpt54Nano = () => new Gpt54Nano();
export const OpenAiModel$isGpt54Nano = (value) => value instanceof Gpt54Nano;

export class Gpt55 extends $CustomType {}
export const OpenAiModel$Gpt55 = () => new Gpt55();
export const OpenAiModel$isGpt55 = (value) => value instanceof Gpt55;

export class Gpt56Sol extends $CustomType {}
export const OpenAiModel$Gpt56Sol = () => new Gpt56Sol();
export const OpenAiModel$isGpt56Sol = (value) => value instanceof Gpt56Sol;

export class Gpt56Terra extends $CustomType {}
export const OpenAiModel$Gpt56Terra = () => new Gpt56Terra();
export const OpenAiModel$isGpt56Terra = (value) => value instanceof Gpt56Terra;

export class Gpt56Luna extends $CustomType {}
export const OpenAiModel$Gpt56Luna = () => new Gpt56Luna();
export const OpenAiModel$isGpt56Luna = (value) => value instanceof Gpt56Luna;

export class Gpt6Astra extends $CustomType {}
export const OpenAiModel$Gpt6Astra = () => new Gpt6Astra();
export const OpenAiModel$isGpt6Astra = (value) => value instanceof Gpt6Astra;

export class Gpt6Sol extends $CustomType {}
export const OpenAiModel$Gpt6Sol = () => new Gpt6Sol();
export const OpenAiModel$isGpt6Sol = (value) => value instanceof Gpt6Sol;

export class Gpt6Luna extends $CustomType {}
export const OpenAiModel$Gpt6Luna = () => new Gpt6Luna();
export const OpenAiModel$isGpt6Luna = (value) => value instanceof Gpt6Luna;

export class BedrockClaude37Sonnet extends $CustomType {}
export const BedrockModel$BedrockClaude37Sonnet = () =>
  new BedrockClaude37Sonnet();
export const BedrockModel$isBedrockClaude37Sonnet = (value) =>
  value instanceof BedrockClaude37Sonnet;

export class BedrockClaudeSonnet4 extends $CustomType {}
export const BedrockModel$BedrockClaudeSonnet4 = () =>
  new BedrockClaudeSonnet4();
export const BedrockModel$isBedrockClaudeSonnet4 = (value) =>
  value instanceof BedrockClaudeSonnet4;

export class BedrockClaudeOpus45 extends $CustomType {}
export const BedrockModel$BedrockClaudeOpus45 = () => new BedrockClaudeOpus45();
export const BedrockModel$isBedrockClaudeOpus45 = (value) =>
  value instanceof BedrockClaudeOpus45;

export class BedrockClaudeSonnet45 extends $CustomType {}
export const BedrockModel$BedrockClaudeSonnet45 = () =>
  new BedrockClaudeSonnet45();
export const BedrockModel$isBedrockClaudeSonnet45 = (value) =>
  value instanceof BedrockClaudeSonnet45;

export class BedrockClaudeHaiku45 extends $CustomType {}
export const BedrockModel$BedrockClaudeHaiku45 = () =>
  new BedrockClaudeHaiku45();
export const BedrockModel$isBedrockClaudeHaiku45 = (value) =>
  value instanceof BedrockClaudeHaiku45;

export class BedrockClaudeSonnet46 extends $CustomType {}
export const BedrockModel$BedrockClaudeSonnet46 = () =>
  new BedrockClaudeSonnet46();
export const BedrockModel$isBedrockClaudeSonnet46 = (value) =>
  value instanceof BedrockClaudeSonnet46;

export class BedrockClaudeOpus47 extends $CustomType {}
export const BedrockModel$BedrockClaudeOpus47 = () => new BedrockClaudeOpus47();
export const BedrockModel$isBedrockClaudeOpus47 = (value) =>
  value instanceof BedrockClaudeOpus47;

export class BedrockClaudeOpus48 extends $CustomType {}
export const BedrockModel$BedrockClaudeOpus48 = () => new BedrockClaudeOpus48();
export const BedrockModel$isBedrockClaudeOpus48 = (value) =>
  value instanceof BedrockClaudeOpus48;

export class BedrockClaudeOpus5 extends $CustomType {}
export const BedrockModel$BedrockClaudeOpus5 = () => new BedrockClaudeOpus5();
export const BedrockModel$isBedrockClaudeOpus5 = (value) =>
  value instanceof BedrockClaudeOpus5;

export class BedrockClaudeSonnet5 extends $CustomType {}
export const BedrockModel$BedrockClaudeSonnet5 = () =>
  new BedrockClaudeSonnet5();
export const BedrockModel$isBedrockClaudeSonnet5 = (value) =>
  value instanceof BedrockClaudeSonnet5;

export class BedrockDeepSeek extends $CustomType {}
export const BedrockModel$BedrockDeepSeek = () => new BedrockDeepSeek();
export const BedrockModel$isBedrockDeepSeek = (value) =>
  value instanceof BedrockDeepSeek;

export class Gemini25Flash extends $CustomType {}
export const GeminiModel$Gemini25Flash = () => new Gemini25Flash();
export const GeminiModel$isGemini25Flash = (value) =>
  value instanceof Gemini25Flash;

export class Gemini25Pro extends $CustomType {}
export const GeminiModel$Gemini25Pro = () => new Gemini25Pro();
export const GeminiModel$isGemini25Pro = (value) =>
  value instanceof Gemini25Pro;

export class Gemini38Flash extends $CustomType {}
export const GeminiModel$Gemini38Flash = () => new Gemini38Flash();
export const GeminiModel$isGemini38Flash = (value) =>
  value instanceof Gemini38Flash;

export class Gemini37Flash extends $CustomType {}
export const GeminiModel$Gemini37Flash = () => new Gemini37Flash();
export const GeminiModel$isGemini37Flash = (value) =>
  value instanceof Gemini37Flash;

export class Gemini36Flash extends $CustomType {}
export const GeminiModel$Gemini36Flash = () => new Gemini36Flash();
export const GeminiModel$isGemini36Flash = (value) =>
  value instanceof Gemini36Flash;

export class Gemini35Flash extends $CustomType {}
export const GeminiModel$Gemini35Flash = () => new Gemini35Flash();
export const GeminiModel$isGemini35Flash = (value) =>
  value instanceof Gemini35Flash;

export class Gemini35FlashLite extends $CustomType {}
export const GeminiModel$Gemini35FlashLite = () => new Gemini35FlashLite();
export const GeminiModel$isGemini35FlashLite = (value) =>
  value instanceof Gemini35FlashLite;

export class Gemini31FlashLite extends $CustomType {}
export const GeminiModel$Gemini31FlashLite = () => new Gemini31FlashLite();
export const GeminiModel$isGemini31FlashLite = (value) =>
  value instanceof Gemini31FlashLite;

export class Gemini31ProPreview extends $CustomType {}
export const GeminiModel$Gemini31ProPreview = () => new Gemini31ProPreview();
export const GeminiModel$isGemini31ProPreview = (value) =>
  value instanceof Gemini31ProPreview;

export class ClaudeHaiku45 extends $CustomType {}
export const AnthropicModel$ClaudeHaiku45 = () => new ClaudeHaiku45();
export const AnthropicModel$isClaudeHaiku45 = (value) =>
  value instanceof ClaudeHaiku45;

export class ClaudeOpus46 extends $CustomType {}
export const AnthropicModel$ClaudeOpus46 = () => new ClaudeOpus46();
export const AnthropicModel$isClaudeOpus46 = (value) =>
  value instanceof ClaudeOpus46;

export class ClaudeOpus47 extends $CustomType {}
export const AnthropicModel$ClaudeOpus47 = () => new ClaudeOpus47();
export const AnthropicModel$isClaudeOpus47 = (value) =>
  value instanceof ClaudeOpus47;

export class ClaudeOpus48 extends $CustomType {}
export const AnthropicModel$ClaudeOpus48 = () => new ClaudeOpus48();
export const AnthropicModel$isClaudeOpus48 = (value) =>
  value instanceof ClaudeOpus48;

export class ClaudeOpus5 extends $CustomType {}
export const AnthropicModel$ClaudeOpus5 = () => new ClaudeOpus5();
export const AnthropicModel$isClaudeOpus5 = (value) =>
  value instanceof ClaudeOpus5;

export class ClaudeSonnet46 extends $CustomType {}
export const AnthropicModel$ClaudeSonnet46 = () => new ClaudeSonnet46();
export const AnthropicModel$isClaudeSonnet46 = (value) =>
  value instanceof ClaudeSonnet46;

export class ClaudeSonnet5 extends $CustomType {}
export const AnthropicModel$ClaudeSonnet5 = () => new ClaudeSonnet5();
export const AnthropicModel$isClaudeSonnet5 = (value) =>
  value instanceof ClaudeSonnet5;

export class ClaudeFable5 extends $CustomType {}
export const AnthropicModel$ClaudeFable5 = () => new ClaudeFable5();
export const AnthropicModel$isClaudeFable5 = (value) =>
  value instanceof ClaudeFable5;

export class ClaudeFable51 extends $CustomType {}
export const AnthropicModel$ClaudeFable51 = () => new ClaudeFable51();
export const AnthropicModel$isClaudeFable51 = (value) =>
  value instanceof ClaudeFable51;

export class ClaudeOpus55 extends $CustomType {}
export const AnthropicModel$ClaudeOpus55 = () => new ClaudeOpus55();
export const AnthropicModel$isClaudeOpus55 = (value) =>
  value instanceof ClaudeOpus55;

export class AiConfig extends $CustomType {
  constructor(org_id, config) {
    super();
    this.org_id = org_id;
    this.config = config;
  }
}
export const AiConfig$AiConfig = (org_id, config) =>
  new AiConfig(org_id, config);
export const AiConfig$isAiConfig = (value) => value instanceof AiConfig;
export const AiConfig$AiConfig$org_id = (value) => value.org_id;
export const AiConfig$AiConfig$0 = (value) => value.org_id;
export const AiConfig$AiConfig$config = (value) => value.config;
export const AiConfig$AiConfig$1 = (value) => value.config;

export class Config extends $CustomType {
  constructor(style_guidelines, ai_system, llm_config, models_config, query_config, retriever_config, pii_vocabulary, context_window, llm_judge_in_the_loop, website_prompt_config, read_collection_variant, write_collection_variant, prev_write_collection_variant) {
    super();
    this.style_guidelines = style_guidelines;
    this.ai_system = ai_system;
    this.llm_config = llm_config;
    this.models_config = models_config;
    this.query_config = query_config;
    this.retriever_config = retriever_config;
    this.pii_vocabulary = pii_vocabulary;
    this.context_window = context_window;
    this.llm_judge_in_the_loop = llm_judge_in_the_loop;
    this.website_prompt_config = website_prompt_config;
    this.read_collection_variant = read_collection_variant;
    this.write_collection_variant = write_collection_variant;
    this.prev_write_collection_variant = prev_write_collection_variant;
  }
}
export const Config$Config = (style_guidelines, ai_system, llm_config, models_config, query_config, retriever_config, pii_vocabulary, context_window, llm_judge_in_the_loop, website_prompt_config, read_collection_variant, write_collection_variant, prev_write_collection_variant) =>
  new Config(style_guidelines,
  ai_system,
  llm_config,
  models_config,
  query_config,
  retriever_config,
  pii_vocabulary,
  context_window,
  llm_judge_in_the_loop,
  website_prompt_config,
  read_collection_variant,
  write_collection_variant,
  prev_write_collection_variant);
export const Config$isConfig = (value) => value instanceof Config;
export const Config$Config$style_guidelines = (value) => value.style_guidelines;
export const Config$Config$0 = (value) => value.style_guidelines;
export const Config$Config$ai_system = (value) => value.ai_system;
export const Config$Config$1 = (value) => value.ai_system;
export const Config$Config$llm_config = (value) => value.llm_config;
export const Config$Config$2 = (value) => value.llm_config;
export const Config$Config$models_config = (value) => value.models_config;
export const Config$Config$3 = (value) => value.models_config;
export const Config$Config$query_config = (value) => value.query_config;
export const Config$Config$4 = (value) => value.query_config;
export const Config$Config$retriever_config = (value) => value.retriever_config;
export const Config$Config$5 = (value) => value.retriever_config;
export const Config$Config$pii_vocabulary = (value) => value.pii_vocabulary;
export const Config$Config$6 = (value) => value.pii_vocabulary;
export const Config$Config$context_window = (value) => value.context_window;
export const Config$Config$7 = (value) => value.context_window;
export const Config$Config$llm_judge_in_the_loop = (value) =>
  value.llm_judge_in_the_loop;
export const Config$Config$8 = (value) => value.llm_judge_in_the_loop;
export const Config$Config$website_prompt_config = (value) =>
  value.website_prompt_config;
export const Config$Config$9 = (value) => value.website_prompt_config;
export const Config$Config$read_collection_variant = (value) =>
  value.read_collection_variant;
export const Config$Config$10 = (value) => value.read_collection_variant;
export const Config$Config$write_collection_variant = (value) =>
  value.write_collection_variant;
export const Config$Config$11 = (value) => value.write_collection_variant;
export const Config$Config$prev_write_collection_variant = (value) =>
  value.prev_write_collection_variant;
export const Config$Config$12 = (value) => value.prev_write_collection_variant;

export class AdvancedRag extends $CustomType {}
export const AiSystem$AdvancedRag = () => new AdvancedRag();
export const AiSystem$isAdvancedRag = (value) => value instanceof AdvancedRag;

export class AgenticRag extends $CustomType {}
export const AiSystem$AgenticRag = () => new AgenticRag();
export const AiSystem$isAgenticRag = (value) => value instanceof AgenticRag;

export class QuestionAnswerV1 extends $CustomType {}
export const RagPrompt$QuestionAnswerV1 = () => new QuestionAnswerV1();
export const RagPrompt$isQuestionAnswerV1 = (value) =>
  value instanceof QuestionAnswerV1;

export class QuestionAnswerV2 extends $CustomType {}
export const RagPrompt$QuestionAnswerV2 = () => new QuestionAnswerV2();
export const RagPrompt$isQuestionAnswerV2 = (value) =>
  value instanceof QuestionAnswerV2;

export class AssessRequirementV1 extends $CustomType {}
export const RagPrompt$AssessRequirementV1 = () => new AssessRequirementV1();
export const RagPrompt$isAssessRequirementV1 = (value) =>
  value instanceof AssessRequirementV1;

export class AssessRequirementV2 extends $CustomType {}
export const RagPrompt$AssessRequirementV2 = () => new AssessRequirementV2();
export const RagPrompt$isAssessRequirementV2 = (value) =>
  value instanceof AssessRequirementV2;

export class Modular extends $CustomType {}
export const RagPrompt$Modular = () => new Modular();
export const RagPrompt$isModular = (value) => value instanceof Modular;

export class ReasoningLow extends $CustomType {}
export const ReasoningEffort$ReasoningLow = () => new ReasoningLow();
export const ReasoningEffort$isReasoningLow = (value) =>
  value instanceof ReasoningLow;

export class ReasoningMedium extends $CustomType {}
export const ReasoningEffort$ReasoningMedium = () => new ReasoningMedium();
export const ReasoningEffort$isReasoningMedium = (value) =>
  value instanceof ReasoningMedium;

export class ReasoningHigh extends $CustomType {}
export const ReasoningEffort$ReasoningHigh = () => new ReasoningHigh();
export const ReasoningEffort$isReasoningHigh = (value) =>
  value instanceof ReasoningHigh;

export class VerbosityLow extends $CustomType {}
export const Verbosity$VerbosityLow = () => new VerbosityLow();
export const Verbosity$isVerbosityLow = (value) =>
  value instanceof VerbosityLow;

export class VerbosityMedium extends $CustomType {}
export const Verbosity$VerbosityMedium = () => new VerbosityMedium();
export const Verbosity$isVerbosityMedium = (value) =>
  value instanceof VerbosityMedium;

export class VerbosityHigh extends $CustomType {}
export const Verbosity$VerbosityHigh = () => new VerbosityHigh();
export const Verbosity$isVerbosityHigh = (value) =>
  value instanceof VerbosityHigh;

export class ComputeScoreV1 extends $CustomType {}
export const ScorePrompt$ComputeScoreV1 = () => new ComputeScoreV1();
export const ScorePrompt$isComputeScoreV1 = (value) =>
  value instanceof ComputeScoreV1;

export class ComputeScoreV2 extends $CustomType {}
export const ScorePrompt$ComputeScoreV2 = () => new ComputeScoreV2();
export const ScorePrompt$isComputeScoreV2 = (value) =>
  value instanceof ComputeScoreV2;

export class LLMConfig extends $CustomType {
  constructor(limit) {
    super();
    this.limit = limit;
  }
}
export const LLMConfig$LLMConfig = (limit) => new LLMConfig(limit);
export const LLMConfig$isLLMConfig = (value) => value instanceof LLMConfig;
export const LLMConfig$LLMConfig$limit = (value) => value.limit;
export const LLMConfig$LLMConfig$0 = (value) => value.limit;

export class ModelsConfig extends $CustomType {
  constructor(rag, rag_temperature, rag_prompt, rag_modular_config, rag_structured_call, run_style_prompt, convert_markdown_to_html, reasoning_effort, verbosity, compute_score_prompt, style_2, summary, classifier, translate_model, conversational_model, eval_model, default_model, website_scrapping_model, search_model, rows_columns_detection_model, advanced_cell_detection_model, docx_question_detection_model, website_capture_model, answer_instruction_model, agentic_loop_driver_model, default_fallback_models) {
    super();
    this.rag = rag;
    this.rag_temperature = rag_temperature;
    this.rag_prompt = rag_prompt;
    this.rag_modular_config = rag_modular_config;
    this.rag_structured_call = rag_structured_call;
    this.run_style_prompt = run_style_prompt;
    this.convert_markdown_to_html = convert_markdown_to_html;
    this.reasoning_effort = reasoning_effort;
    this.verbosity = verbosity;
    this.compute_score_prompt = compute_score_prompt;
    this.style_2 = style_2;
    this.summary = summary;
    this.classifier = classifier;
    this.translate_model = translate_model;
    this.conversational_model = conversational_model;
    this.eval_model = eval_model;
    this.default_model = default_model;
    this.website_scrapping_model = website_scrapping_model;
    this.search_model = search_model;
    this.rows_columns_detection_model = rows_columns_detection_model;
    this.advanced_cell_detection_model = advanced_cell_detection_model;
    this.docx_question_detection_model = docx_question_detection_model;
    this.website_capture_model = website_capture_model;
    this.answer_instruction_model = answer_instruction_model;
    this.agentic_loop_driver_model = agentic_loop_driver_model;
    this.default_fallback_models = default_fallback_models;
  }
}
export const ModelsConfig$ModelsConfig = (rag, rag_temperature, rag_prompt, rag_modular_config, rag_structured_call, run_style_prompt, convert_markdown_to_html, reasoning_effort, verbosity, compute_score_prompt, style_2, summary, classifier, translate_model, conversational_model, eval_model, default_model, website_scrapping_model, search_model, rows_columns_detection_model, advanced_cell_detection_model, docx_question_detection_model, website_capture_model, answer_instruction_model, agentic_loop_driver_model, default_fallback_models) =>
  new ModelsConfig(rag,
  rag_temperature,
  rag_prompt,
  rag_modular_config,
  rag_structured_call,
  run_style_prompt,
  convert_markdown_to_html,
  reasoning_effort,
  verbosity,
  compute_score_prompt,
  style_2,
  summary,
  classifier,
  translate_model,
  conversational_model,
  eval_model,
  default_model,
  website_scrapping_model,
  search_model,
  rows_columns_detection_model,
  advanced_cell_detection_model,
  docx_question_detection_model,
  website_capture_model,
  answer_instruction_model,
  agentic_loop_driver_model,
  default_fallback_models);
export const ModelsConfig$isModelsConfig = (value) =>
  value instanceof ModelsConfig;
export const ModelsConfig$ModelsConfig$rag = (value) => value.rag;
export const ModelsConfig$ModelsConfig$0 = (value) => value.rag;
export const ModelsConfig$ModelsConfig$rag_temperature = (value) =>
  value.rag_temperature;
export const ModelsConfig$ModelsConfig$1 = (value) => value.rag_temperature;
export const ModelsConfig$ModelsConfig$rag_prompt = (value) => value.rag_prompt;
export const ModelsConfig$ModelsConfig$2 = (value) => value.rag_prompt;
export const ModelsConfig$ModelsConfig$rag_modular_config = (value) =>
  value.rag_modular_config;
export const ModelsConfig$ModelsConfig$3 = (value) => value.rag_modular_config;
export const ModelsConfig$ModelsConfig$rag_structured_call = (value) =>
  value.rag_structured_call;
export const ModelsConfig$ModelsConfig$4 = (value) => value.rag_structured_call;
export const ModelsConfig$ModelsConfig$run_style_prompt = (value) =>
  value.run_style_prompt;
export const ModelsConfig$ModelsConfig$5 = (value) => value.run_style_prompt;
export const ModelsConfig$ModelsConfig$convert_markdown_to_html = (value) =>
  value.convert_markdown_to_html;
export const ModelsConfig$ModelsConfig$6 = (value) =>
  value.convert_markdown_to_html;
export const ModelsConfig$ModelsConfig$reasoning_effort = (value) =>
  value.reasoning_effort;
export const ModelsConfig$ModelsConfig$7 = (value) => value.reasoning_effort;
export const ModelsConfig$ModelsConfig$verbosity = (value) => value.verbosity;
export const ModelsConfig$ModelsConfig$8 = (value) => value.verbosity;
export const ModelsConfig$ModelsConfig$compute_score_prompt = (value) =>
  value.compute_score_prompt;
export const ModelsConfig$ModelsConfig$9 = (value) =>
  value.compute_score_prompt;
export const ModelsConfig$ModelsConfig$style_2 = (value) => value.style_2;
export const ModelsConfig$ModelsConfig$10 = (value) => value.style_2;
export const ModelsConfig$ModelsConfig$summary = (value) => value.summary;
export const ModelsConfig$ModelsConfig$11 = (value) => value.summary;
export const ModelsConfig$ModelsConfig$classifier = (value) => value.classifier;
export const ModelsConfig$ModelsConfig$12 = (value) => value.classifier;
export const ModelsConfig$ModelsConfig$translate_model = (value) =>
  value.translate_model;
export const ModelsConfig$ModelsConfig$13 = (value) => value.translate_model;
export const ModelsConfig$ModelsConfig$conversational_model = (value) =>
  value.conversational_model;
export const ModelsConfig$ModelsConfig$14 = (value) =>
  value.conversational_model;
export const ModelsConfig$ModelsConfig$eval_model = (value) => value.eval_model;
export const ModelsConfig$ModelsConfig$15 = (value) => value.eval_model;
export const ModelsConfig$ModelsConfig$default_model = (value) =>
  value.default_model;
export const ModelsConfig$ModelsConfig$16 = (value) => value.default_model;
export const ModelsConfig$ModelsConfig$website_scrapping_model = (value) =>
  value.website_scrapping_model;
export const ModelsConfig$ModelsConfig$17 = (value) =>
  value.website_scrapping_model;
export const ModelsConfig$ModelsConfig$search_model = (value) =>
  value.search_model;
export const ModelsConfig$ModelsConfig$18 = (value) => value.search_model;
export const ModelsConfig$ModelsConfig$rows_columns_detection_model = (value) =>
  value.rows_columns_detection_model;
export const ModelsConfig$ModelsConfig$19 = (value) =>
  value.rows_columns_detection_model;
export const ModelsConfig$ModelsConfig$advanced_cell_detection_model = (value) =>
  value.advanced_cell_detection_model;
export const ModelsConfig$ModelsConfig$20 = (value) =>
  value.advanced_cell_detection_model;
export const ModelsConfig$ModelsConfig$docx_question_detection_model = (value) =>
  value.docx_question_detection_model;
export const ModelsConfig$ModelsConfig$21 = (value) =>
  value.docx_question_detection_model;
export const ModelsConfig$ModelsConfig$website_capture_model = (value) =>
  value.website_capture_model;
export const ModelsConfig$ModelsConfig$22 = (value) =>
  value.website_capture_model;
export const ModelsConfig$ModelsConfig$answer_instruction_model = (value) =>
  value.answer_instruction_model;
export const ModelsConfig$ModelsConfig$23 = (value) =>
  value.answer_instruction_model;
export const ModelsConfig$ModelsConfig$agentic_loop_driver_model = (value) =>
  value.agentic_loop_driver_model;
export const ModelsConfig$ModelsConfig$24 = (value) =>
  value.agentic_loop_driver_model;
export const ModelsConfig$ModelsConfig$default_fallback_models = (value) =>
  value.default_fallback_models;
export const ModelsConfig$ModelsConfig$25 = (value) =>
  value.default_fallback_models;

export class AgenticRetrievalConfig extends $CustomType {
  constructor(max_iterations, max_docs, max_queries) {
    super();
    this.max_iterations = max_iterations;
    this.max_docs = max_docs;
    this.max_queries = max_queries;
  }
}
export const AgenticRetrievalConfig$AgenticRetrievalConfig = (max_iterations, max_docs, max_queries) =>
  new AgenticRetrievalConfig(max_iterations, max_docs, max_queries);
export const AgenticRetrievalConfig$isAgenticRetrievalConfig = (value) =>
  value instanceof AgenticRetrievalConfig;
export const AgenticRetrievalConfig$AgenticRetrievalConfig$max_iterations = (value) =>
  value.max_iterations;
export const AgenticRetrievalConfig$AgenticRetrievalConfig$0 = (value) =>
  value.max_iterations;
export const AgenticRetrievalConfig$AgenticRetrievalConfig$max_docs = (value) =>
  value.max_docs;
export const AgenticRetrievalConfig$AgenticRetrievalConfig$1 = (value) =>
  value.max_docs;
export const AgenticRetrievalConfig$AgenticRetrievalConfig$max_queries = (value) =>
  value.max_queries;
export const AgenticRetrievalConfig$AgenticRetrievalConfig$2 = (value) =>
  value.max_queries;

export class QueryConfig extends $CustomType {
  constructor(limit, alpha, parent_lookup, hyde, extract_question, minimal_score, split_query, use_dates, agentic_retrieval) {
    super();
    this.limit = limit;
    this.alpha = alpha;
    this.parent_lookup = parent_lookup;
    this.hyde = hyde;
    this.extract_question = extract_question;
    this.minimal_score = minimal_score;
    this.split_query = split_query;
    this.use_dates = use_dates;
    this.agentic_retrieval = agentic_retrieval;
  }
}
export const QueryConfig$QueryConfig = (limit, alpha, parent_lookup, hyde, extract_question, minimal_score, split_query, use_dates, agentic_retrieval) =>
  new QueryConfig(limit,
  alpha,
  parent_lookup,
  hyde,
  extract_question,
  minimal_score,
  split_query,
  use_dates,
  agentic_retrieval);
export const QueryConfig$isQueryConfig = (value) =>
  value instanceof QueryConfig;
export const QueryConfig$QueryConfig$limit = (value) => value.limit;
export const QueryConfig$QueryConfig$0 = (value) => value.limit;
export const QueryConfig$QueryConfig$alpha = (value) => value.alpha;
export const QueryConfig$QueryConfig$1 = (value) => value.alpha;
export const QueryConfig$QueryConfig$parent_lookup = (value) =>
  value.parent_lookup;
export const QueryConfig$QueryConfig$2 = (value) => value.parent_lookup;
export const QueryConfig$QueryConfig$hyde = (value) => value.hyde;
export const QueryConfig$QueryConfig$3 = (value) => value.hyde;
export const QueryConfig$QueryConfig$extract_question = (value) =>
  value.extract_question;
export const QueryConfig$QueryConfig$4 = (value) => value.extract_question;
export const QueryConfig$QueryConfig$minimal_score = (value) =>
  value.minimal_score;
export const QueryConfig$QueryConfig$5 = (value) => value.minimal_score;
export const QueryConfig$QueryConfig$split_query = (value) => value.split_query;
export const QueryConfig$QueryConfig$6 = (value) => value.split_query;
export const QueryConfig$QueryConfig$use_dates = (value) => value.use_dates;
export const QueryConfig$QueryConfig$7 = (value) => value.use_dates;
export const QueryConfig$QueryConfig$agentic_retrieval = (value) =>
  value.agentic_retrieval;
export const QueryConfig$QueryConfig$8 = (value) => value.agentic_retrieval;

export class RetrieverConfig extends $CustomType {
  constructor(option) {
    super();
    this.option = option;
  }
}
export const RetrieverConfig$RetrieverConfig = (option) =>
  new RetrieverConfig(option);
export const RetrieverConfig$isRetrieverConfig = (value) =>
  value instanceof RetrieverConfig;
export const RetrieverConfig$RetrieverConfig$option = (value) => value.option;
export const RetrieverConfig$RetrieverConfig$0 = (value) => value.option;

export class ContextWindow extends $CustomType {
  constructor(lookback, lookahead) {
    super();
    this.lookback = lookback;
    this.lookahead = lookahead;
  }
}
export const ContextWindow$ContextWindow = (lookback, lookahead) =>
  new ContextWindow(lookback, lookahead);
export const ContextWindow$isContextWindow = (value) =>
  value instanceof ContextWindow;
export const ContextWindow$ContextWindow$lookback = (value) => value.lookback;
export const ContextWindow$ContextWindow$0 = (value) => value.lookback;
export const ContextWindow$ContextWindow$lookahead = (value) => value.lookahead;
export const ContextWindow$ContextWindow$1 = (value) => value.lookahead;

export class WebsitePromptConfig extends $CustomType {
  constructor(labels_instructions, what_to_ignore, breadcrumbs_instructions) {
    super();
    this.labels_instructions = labels_instructions;
    this.what_to_ignore = what_to_ignore;
    this.breadcrumbs_instructions = breadcrumbs_instructions;
  }
}
export const WebsitePromptConfig$WebsitePromptConfig = (labels_instructions, what_to_ignore, breadcrumbs_instructions) =>
  new WebsitePromptConfig(labels_instructions,
  what_to_ignore,
  breadcrumbs_instructions);
export const WebsitePromptConfig$isWebsitePromptConfig = (value) =>
  value instanceof WebsitePromptConfig;
export const WebsitePromptConfig$WebsitePromptConfig$labels_instructions = (value) =>
  value.labels_instructions;
export const WebsitePromptConfig$WebsitePromptConfig$0 = (value) =>
  value.labels_instructions;
export const WebsitePromptConfig$WebsitePromptConfig$what_to_ignore = (value) =>
  value.what_to_ignore;
export const WebsitePromptConfig$WebsitePromptConfig$1 = (value) =>
  value.what_to_ignore;
export const WebsitePromptConfig$WebsitePromptConfig$breadcrumbs_instructions = (value) =>
  value.breadcrumbs_instructions;
export const WebsitePromptConfig$WebsitePromptConfig$2 = (value) =>
  value.breadcrumbs_instructions;

export class Rag extends $CustomType {}
export const ModelsConfigField$Rag = () => new Rag();
export const ModelsConfigField$isRag = (value) => value instanceof Rag;

export class Style2 extends $CustomType {}
export const ModelsConfigField$Style2 = () => new Style2();
export const ModelsConfigField$isStyle2 = (value) => value instanceof Style2;

export class Summary extends $CustomType {}
export const ModelsConfigField$Summary = () => new Summary();
export const ModelsConfigField$isSummary = (value) => value instanceof Summary;

export class Classifier extends $CustomType {}
export const ModelsConfigField$Classifier = () => new Classifier();
export const ModelsConfigField$isClassifier = (value) =>
  value instanceof Classifier;

export class TranslateModel extends $CustomType {}
export const ModelsConfigField$TranslateModel = () => new TranslateModel();
export const ModelsConfigField$isTranslateModel = (value) =>
  value instanceof TranslateModel;

export class ConversationalModel extends $CustomType {}
export const ModelsConfigField$ConversationalModel = () =>
  new ConversationalModel();
export const ModelsConfigField$isConversationalModel = (value) =>
  value instanceof ConversationalModel;

export class EvalModel extends $CustomType {}
export const ModelsConfigField$EvalModel = () => new EvalModel();
export const ModelsConfigField$isEvalModel = (value) =>
  value instanceof EvalModel;

export class DefaultModel extends $CustomType {}
export const ModelsConfigField$DefaultModel = () => new DefaultModel();
export const ModelsConfigField$isDefaultModel = (value) =>
  value instanceof DefaultModel;

export class WebsiteScrappingModel extends $CustomType {}
export const ModelsConfigField$WebsiteScrappingModel = () =>
  new WebsiteScrappingModel();
export const ModelsConfigField$isWebsiteScrappingModel = (value) =>
  value instanceof WebsiteScrappingModel;

export class SearchModel extends $CustomType {}
export const ModelsConfigField$SearchModel = () => new SearchModel();
export const ModelsConfigField$isSearchModel = (value) =>
  value instanceof SearchModel;

export class RowsColumnsDetectionModel extends $CustomType {}
export const ModelsConfigField$RowsColumnsDetectionModel = () =>
  new RowsColumnsDetectionModel();
export const ModelsConfigField$isRowsColumnsDetectionModel = (value) =>
  value instanceof RowsColumnsDetectionModel;

export class AdvancedCellDetectionModel extends $CustomType {}
export const ModelsConfigField$AdvancedCellDetectionModel = () =>
  new AdvancedCellDetectionModel();
export const ModelsConfigField$isAdvancedCellDetectionModel = (value) =>
  value instanceof AdvancedCellDetectionModel;

export class DocxQuestionDetectionModel extends $CustomType {}
export const ModelsConfigField$DocxQuestionDetectionModel = () =>
  new DocxQuestionDetectionModel();
export const ModelsConfigField$isDocxQuestionDetectionModel = (value) =>
  value instanceof DocxQuestionDetectionModel;

export class WebsiteCaptureModel extends $CustomType {}
export const ModelsConfigField$WebsiteCaptureModel = () =>
  new WebsiteCaptureModel();
export const ModelsConfigField$isWebsiteCaptureModel = (value) =>
  value instanceof WebsiteCaptureModel;

export class AnswerInstructionModel extends $CustomType {}
export const ModelsConfigField$AnswerInstructionModel = () =>
  new AnswerInstructionModel();
export const ModelsConfigField$isAnswerInstructionModel = (value) =>
  value instanceof AnswerInstructionModel;

export class AgenticLoopDriverModel extends $CustomType {}
export const ModelsConfigField$AgenticLoopDriverModel = () =>
  new AgenticLoopDriverModel();
export const ModelsConfigField$isAgenticLoopDriverModel = (value) =>
  value instanceof AgenticLoopDriverModel;

const breadcrumbs_instructions_default = "Extract the page's section hierarchy (breadcrumbs) using the following signals, in order of priority:\n1. JSON-LD structured data — look for <script type=\"application/ld+json\"> containing \"@type\": \"BreadcrumbList\". Extract the name of each itemListElement in order, excluding \"Home\".\n2. Open Graph / meta tags — check for <meta property=\"article:section\"> or <meta name=\"category\">.\n3. Visible breadcrumb nav — look for <nav aria-label=\"breadcrumb\">, <ol class=\"breadcrumb\">, or any element with \"breadcrumb\" in its class/id. Extract the visible link text in order, excluding \"Home\".\n4. URL path — fall back to splitting the URL path into segments (e.g. /blog/tutorials/my-post → [\"blog\", \"tutorials\"]).\n\nReturn the result as a list of strings from most general to most specific, e.g. [\"Blog\", \"Tutorials\"]. If none of the above yield useful results, return an empty list.";

const what_to_ignore_default = "- Header menus and top navigation\n- Footer (Terms, Privacy, Copyright, Cookie policy)\n- Sidebar widgets unrelated to the main content zone\n- Login / signup buttons\n- Social media links\n- Cookie banners and promotional popups\n- Language selector links";

const label_instructions_default = "Tags are usually related to a product name or service name.\nLook for it in various parts of the website, usually before the beginning of the main content.\nSometimes on the side panel of the content.";

export const default_deactivated_context_window_lookahead = 0;

export const default_deactivated_context_window_lookback = 0;

const anthropic_models = /* @__PURE__ */ toList([
  /* @__PURE__ */ new ClaudeHaiku45(),
  /* @__PURE__ */ new ClaudeOpus46(),
  /* @__PURE__ */ new ClaudeOpus47(),
  /* @__PURE__ */ new ClaudeOpus48(),
  /* @__PURE__ */ new ClaudeOpus5(),
  /* @__PURE__ */ new ClaudeSonnet46(),
  /* @__PURE__ */ new ClaudeSonnet5(),
  /* @__PURE__ */ new ClaudeFable5(),
  /* @__PURE__ */ new ClaudeFable51(),
  /* @__PURE__ */ new ClaudeOpus55(),
]);

const gemini_models = /* @__PURE__ */ toList([
  /* @__PURE__ */ new Gemini25Flash(),
  /* @__PURE__ */ new Gemini25Pro(),
  /* @__PURE__ */ new Gemini38Flash(),
  /* @__PURE__ */ new Gemini37Flash(),
  /* @__PURE__ */ new Gemini36Flash(),
  /* @__PURE__ */ new Gemini35Flash(),
  /* @__PURE__ */ new Gemini35FlashLite(),
  /* @__PURE__ */ new Gemini31FlashLite(),
  /* @__PURE__ */ new Gemini31ProPreview(),
]);

const bedrock_models = /* @__PURE__ */ toList([
  /* @__PURE__ */ new BedrockClaude37Sonnet(),
  /* @__PURE__ */ new BedrockClaudeSonnet4(),
  /* @__PURE__ */ new BedrockClaudeOpus45(),
  /* @__PURE__ */ new BedrockClaudeSonnet45(),
  /* @__PURE__ */ new BedrockClaudeHaiku45(),
  /* @__PURE__ */ new BedrockClaudeSonnet46(),
  /* @__PURE__ */ new BedrockClaudeOpus47(),
  /* @__PURE__ */ new BedrockClaudeOpus48(),
  /* @__PURE__ */ new BedrockClaudeOpus5(),
  /* @__PURE__ */ new BedrockClaudeSonnet5(),
  /* @__PURE__ */ new BedrockDeepSeek(),
]);

const openai_models = /* @__PURE__ */ toList([
  /* @__PURE__ */ new Gpt4o(),
  /* @__PURE__ */ new Gpt41Nano(),
  /* @__PURE__ */ new Gpt41Mini(),
  /* @__PURE__ */ new Gpt41(),
  /* @__PURE__ */ new Gpt5Nano(),
  /* @__PURE__ */ new Gpt5Mini(),
  /* @__PURE__ */ new Gpt5(),
  /* @__PURE__ */ new Gpt5ChatLatest(),
  /* @__PURE__ */ new Gpt51(),
  /* @__PURE__ */ new Gpt51ChatLatest(),
  /* @__PURE__ */ new Gpt52(),
  /* @__PURE__ */ new Gpt52ChatLatest(),
  /* @__PURE__ */ new Gpt54Nano(),
  /* @__PURE__ */ new Gpt55(),
  /* @__PURE__ */ new Gpt56Sol(),
  /* @__PURE__ */ new Gpt56Terra(),
  /* @__PURE__ */ new Gpt56Luna(),
  /* @__PURE__ */ new Gpt6Astra(),
  /* @__PURE__ */ new Gpt6Sol(),
  /* @__PURE__ */ new Gpt6Luna(),
]);

const azure_openai_models = /* @__PURE__ */ toList([
  /* @__PURE__ */ new AzureGpt4o(),
  /* @__PURE__ */ new AzureGpt41Mini(),
]);

const azure_ai_models = /* @__PURE__ */ toList([
  /* @__PURE__ */ new AzureGpt5Chat(),
  /* @__PURE__ */ new AzureGpt51Chat(),
  /* @__PURE__ */ new AzureGpt5Nano(),
  /* @__PURE__ */ new AzureLlama4Scout(),
]);

export const models_config_fields = /* @__PURE__ */ toList([
  /* @__PURE__ */ new Rag(),
  /* @__PURE__ */ new Style2(),
  /* @__PURE__ */ new Summary(),
  /* @__PURE__ */ new Classifier(),
  /* @__PURE__ */ new TranslateModel(),
  /* @__PURE__ */ new ConversationalModel(),
  /* @__PURE__ */ new EvalModel(),
  /* @__PURE__ */ new DefaultModel(),
  /* @__PURE__ */ new WebsiteScrappingModel(),
  /* @__PURE__ */ new SearchModel(),
  /* @__PURE__ */ new RowsColumnsDetectionModel(),
  /* @__PURE__ */ new AdvancedCellDetectionModel(),
  /* @__PURE__ */ new DocxQuestionDetectionModel(),
  /* @__PURE__ */ new WebsiteCaptureModel(),
  /* @__PURE__ */ new AnswerInstructionModel(),
  /* @__PURE__ */ new AgenticLoopDriverModel(),
]);

export const default_activated_context_window_lookback = 5;

export const systems = /* @__PURE__ */ toList([
  /* @__PURE__ */ new AdvancedRag(),
  /* @__PURE__ */ new AgenticRag(),
]);

export const rag_prompts = /* @__PURE__ */ toList([
  /* @__PURE__ */ new QuestionAnswerV1(),
  /* @__PURE__ */ new QuestionAnswerV2(),
  /* @__PURE__ */ new AssessRequirementV1(),
  /* @__PURE__ */ new AssessRequirementV2(),
  /* @__PURE__ */ new Modular(),
]);

export const score_prompts = /* @__PURE__ */ toList([
  /* @__PURE__ */ new ComputeScoreV1(),
  /* @__PURE__ */ new ComputeScoreV2(),
]);

export const retriever_options = /* @__PURE__ */ toList([
  /* @__PURE__ */ new Hybrid(),
  /* @__PURE__ */ new Rerank(),
  /* @__PURE__ */ new Fusion(),
]);

export const reasoning_effort_options = /* @__PURE__ */ toList([
  /* @__PURE__ */ new None(),
  /* @__PURE__ */ new Some(/* @__PURE__ */ new ReasoningLow()),
  /* @__PURE__ */ new Some(/* @__PURE__ */ new ReasoningMedium()),
  /* @__PURE__ */ new Some(/* @__PURE__ */ new ReasoningHigh()),
]);

export const verbosity_options = /* @__PURE__ */ toList([
  /* @__PURE__ */ new None(),
  /* @__PURE__ */ new Some(/* @__PURE__ */ new VerbosityLow()),
  /* @__PURE__ */ new Some(/* @__PURE__ */ new VerbosityMedium()),
  /* @__PURE__ */ new Some(/* @__PURE__ */ new VerbosityHigh()),
]);

export const role_options = /* @__PURE__ */ toList([
  /* @__PURE__ */ new RoleOff(),
  /* @__PURE__ */ new RoleRfpExpert(),
]);

export const entity_mismatch_options = /* @__PURE__ */ toList([
  /* @__PURE__ */ new EntityMismatchOff(),
  /* @__PURE__ */ new EntityMismatchDefault(),
]);

export const approach_options = /* @__PURE__ */ toList([
  /* @__PURE__ */ new ApproachOff(),
  /* @__PURE__ */ new ApproachDefault(),
]);

export const tone_style_options = /* @__PURE__ */ toList([
  /* @__PURE__ */ new ToneStyleOff(),
  /* @__PURE__ */ new ToneStyleDefault(),
]);

export const formatting_options = /* @__PURE__ */ toList([
  /* @__PURE__ */ new FormattingOff(),
  /* @__PURE__ */ new FormattingDefault(),
]);

export const evidence_over_assertion_options = /* @__PURE__ */ toList([
  /* @__PURE__ */ new EvidenceOverAssertionOff(),
  /* @__PURE__ */ new EvidenceOverAssertionDefault(),
]);

export const redirect_options = /* @__PURE__ */ toList([
  /* @__PURE__ */ new RedirectOff(),
  /* @__PURE__ */ new RedirectDefault(),
]);

export const tone_voice_options = /* @__PURE__ */ toList([
  /* @__PURE__ */ new ToneVoiceOff(),
  /* @__PURE__ */ new ToneVoiceCustomer(),
  /* @__PURE__ */ new ToneVoiceEngaged(),
  /* @__PURE__ */ new ToneVoiceGeneric(),
]);

export const repeat_question_options = /* @__PURE__ */ toList([
  /* @__PURE__ */ new RepeatQuestionOff(),
  /* @__PURE__ */ new Repeat(),
  /* @__PURE__ */ new DoNotRepeat(),
  /* @__PURE__ */ new DoNotRepeatWarm(),
]);

export const length_rule_options = /* @__PURE__ */ toList([
  /* @__PURE__ */ new LengthRuleOff(),
  /* @__PURE__ */ new CategoryBased(),
  /* @__PURE__ */ new Generalistic(),
]);

export const what_to_return_options = /* @__PURE__ */ toList([
  /* @__PURE__ */ new WhatToReturnOff(),
  /* @__PURE__ */ new ReturnJson(),
  /* @__PURE__ */ new ReturnText(),
]);

/**
 * Models offered in the UI. Retired models stay in `ModelType` so stored
 * configs still decode to what they actually name, but are left out of this
 * list; re-enabling one means adding it back here and to nabu's registry.
 */
export const all_models = /* @__PURE__ */ toList([
  /* @__PURE__ */ new OpenAi(/* @__PURE__ */ new Gpt5Nano()),
  /* @__PURE__ */ new OpenAi(/* @__PURE__ */ new Gpt5Mini()),
  /* @__PURE__ */ new OpenAi(/* @__PURE__ */ new Gpt5()),
  /* @__PURE__ */ new OpenAi(/* @__PURE__ */ new Gpt51()),
  /* @__PURE__ */ new OpenAi(/* @__PURE__ */ new Gpt52()),
  /* @__PURE__ */ new OpenAi(/* @__PURE__ */ new Gpt54Nano()),
  /* @__PURE__ */ new OpenAi(/* @__PURE__ */ new Gpt55()),
  /* @__PURE__ */ new OpenAi(/* @__PURE__ */ new Gpt56Sol()),
  /* @__PURE__ */ new OpenAi(/* @__PURE__ */ new Gpt56Terra()),
  /* @__PURE__ */ new OpenAi(/* @__PURE__ */ new Gpt56Luna()),
  /* @__PURE__ */ new OpenAi(/* @__PURE__ */ new Gpt6Astra()),
  /* @__PURE__ */ new OpenAi(/* @__PURE__ */ new Gpt6Sol()),
  /* @__PURE__ */ new OpenAi(/* @__PURE__ */ new Gpt6Luna()),
  /* @__PURE__ */ new Anthropic(/* @__PURE__ */ new ClaudeHaiku45()),
  /* @__PURE__ */ new Anthropic(/* @__PURE__ */ new ClaudeOpus46()),
  /* @__PURE__ */ new Anthropic(/* @__PURE__ */ new ClaudeOpus47()),
  /* @__PURE__ */ new Anthropic(/* @__PURE__ */ new ClaudeOpus48()),
  /* @__PURE__ */ new Anthropic(/* @__PURE__ */ new ClaudeOpus5()),
  /* @__PURE__ */ new Anthropic(/* @__PURE__ */ new ClaudeSonnet46()),
  /* @__PURE__ */ new Anthropic(/* @__PURE__ */ new ClaudeSonnet5()),
  /* @__PURE__ */ new Anthropic(/* @__PURE__ */ new ClaudeFable5()),
  /* @__PURE__ */ new Anthropic(/* @__PURE__ */ new ClaudeFable51()),
  /* @__PURE__ */ new Anthropic(/* @__PURE__ */ new ClaudeOpus55()),
  /* @__PURE__ */ new Bedrock(/* @__PURE__ */ new BedrockClaudeOpus45()),
  /* @__PURE__ */ new Bedrock(/* @__PURE__ */ new BedrockClaudeSonnet45()),
  /* @__PURE__ */ new Bedrock(/* @__PURE__ */ new BedrockClaudeHaiku45()),
  /* @__PURE__ */ new Bedrock(/* @__PURE__ */ new BedrockClaudeSonnet46()),
  /* @__PURE__ */ new Bedrock(/* @__PURE__ */ new BedrockClaudeOpus47()),
  /* @__PURE__ */ new Bedrock(/* @__PURE__ */ new BedrockClaudeOpus48()),
  /* @__PURE__ */ new Bedrock(/* @__PURE__ */ new BedrockClaudeOpus5()),
  /* @__PURE__ */ new Bedrock(/* @__PURE__ */ new BedrockClaudeSonnet5()),
  /* @__PURE__ */ new Bedrock(/* @__PURE__ */ new BedrockDeepSeek()),
  /* @__PURE__ */ new Gemini(/* @__PURE__ */ new Gemini25Flash()),
  /* @__PURE__ */ new Gemini(/* @__PURE__ */ new Gemini25Pro()),
  /* @__PURE__ */ new Gemini(/* @__PURE__ */ new Gemini38Flash()),
  /* @__PURE__ */ new Gemini(/* @__PURE__ */ new Gemini37Flash()),
  /* @__PURE__ */ new Gemini(/* @__PURE__ */ new Gemini36Flash()),
  /* @__PURE__ */ new Gemini(/* @__PURE__ */ new Gemini35Flash()),
  /* @__PURE__ */ new Gemini(/* @__PURE__ */ new Gemini35FlashLite()),
  /* @__PURE__ */ new Gemini(/* @__PURE__ */ new Gemini31FlashLite()),
  /* @__PURE__ */ new Gemini(/* @__PURE__ */ new Gemini31ProPreview()),
]);

function default_website_prompt_config() {
  return new WebsitePromptConfig(
    label_instructions_default,
    what_to_ignore_default,
    breadcrumbs_instructions_default,
  );
}

function website_prompt_config_decoder() {
  return $decrypt.optional_field(
    "labels_instructions",
    $decode.string,
    (labels_instructions) => {
      let labels_instructions$1 = $option.unwrap(
        labels_instructions,
        label_instructions_default,
      );
      return $decrypt.optional_field(
        "what_to_ignore",
        $decode.string,
        (what_to_ignore) => {
          let what_to_ignore$1 = $option.unwrap(
            what_to_ignore,
            what_to_ignore_default,
          );
          return $decrypt.optional_field(
            "breadcrumbs_instructions",
            $decode.string,
            (breadcrumbs_instructions) => {
              let breadcrumbs_instructions$1 = $option.unwrap(
                breadcrumbs_instructions,
                breadcrumbs_instructions_default,
              );
              return $decode.success(
                new WebsitePromptConfig(
                  labels_instructions$1,
                  what_to_ignore$1,
                  breadcrumbs_instructions$1,
                ),
              );
            },
          );
        },
      );
    },
  );
}

function context_window_decoder() {
  return $decode.field(
    "lookback",
    $decode.int,
    (lookback) => {
      return $decode.field(
        "lookahead",
        $decode.int,
        (lookahead) => {
          return $decode.success(new ContextWindow(lookback, lookahead));
        },
      );
    },
  );
}

function retriever_option_type_decoder() {
  return $decode.then$(
    $decode.string,
    (option) => {
      let expected = "hybrid | rerank | fusion";
      if (option === "hybrid") {
        return $decode.success(new Hybrid());
      } else if (option === "rerank") {
        return $decode.success(new Rerank());
      } else if (option === "fusion") {
        return $decode.success(new Fusion());
      } else {
        return $decode.failure(new Hybrid(), expected);
      }
    },
  );
}

function retriever_config_decoder() {
  return $decode.field(
    "option",
    retriever_option_type_decoder(),
    (option) => { return $decode.success(new RetrieverConfig(option)); },
  );
}

function agentic_retrieval_decoder() {
  return $decode.field(
    "max_iterations",
    $decode.int,
    (max_iterations) => {
      return $decode.field(
        "max_docs",
        $decode.int,
        (max_docs) => {
          return $decode.field(
            "max_queries",
            $decode.int,
            (max_queries) => {
              return $decode.success(
                new AgenticRetrievalConfig(
                  max_iterations,
                  max_docs,
                  max_queries,
                ),
              );
            },
          );
        },
      );
    },
  );
}

function query_config_decoder() {
  return $decode.field(
    "limit",
    $decode.int,
    (limit) => {
      return $decode.field(
        "alpha",
        $decrypt.float(),
        (alpha) => {
          return $decode.field(
            "parent_lookup",
            $decode.bool,
            (parent_lookup) => {
              return $decode.field(
                "hyde",
                $decode.bool,
                (hyde) => {
                  return $decode.field(
                    "extract_question",
                    $decode.bool,
                    (extract_question) => {
                      return $decode.field(
                        "minimal_score",
                        $decode.one_of(
                          $decode.float,
                          toList([$decode.map($decode.int, $int.to_float)]),
                        ),
                        (minimal_score) => {
                          return $decode.field(
                            "split_query",
                            $decode.bool,
                            (split_query) => {
                              return $decrypt.optional_field(
                                "use_dates",
                                $decode.bool,
                                (use_dates) => {
                                  return $decrypt.optional_field(
                                    "agentic_retrieval",
                                    agentic_retrieval_decoder(),
                                    (agentic_retrieval) => {
                                      let use_dates$1 = $option.unwrap(
                                        use_dates,
                                        false,
                                      );
                                      return $decode.success(
                                        new QueryConfig(
                                          limit,
                                          alpha,
                                          parent_lookup,
                                          hyde,
                                          extract_question,
                                          minimal_score,
                                          split_query,
                                          use_dates$1,
                                          agentic_retrieval,
                                        ),
                                      );
                                    },
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

function anthropic_model_name(model) {
  if (model instanceof ClaudeHaiku45) {
    return "claude-haiku-4-5-20251001";
  } else if (model instanceof ClaudeOpus46) {
    return "claude-opus-4-6";
  } else if (model instanceof ClaudeOpus47) {
    return "claude-opus-4-7";
  } else if (model instanceof ClaudeOpus48) {
    return "claude-opus-4-8";
  } else if (model instanceof ClaudeOpus5) {
    return "claude-opus-5";
  } else if (model instanceof ClaudeSonnet46) {
    return "claude-sonnet-4-6";
  } else if (model instanceof ClaudeSonnet5) {
    return "claude-sonnet-5";
  } else if (model instanceof ClaudeFable5) {
    return "claude-fable-5";
  } else if (model instanceof ClaudeFable51) {
    return "claude-fable-5-1";
  } else {
    return "claude-opus-5-5";
  }
}

function find_model(name, models, model_name, provider) {
  let _pipe = $list.find(
    models,
    (model) => { return model_name(model) === name; },
  );
  return $result.map(_pipe, provider);
}

function gemini_model_name(model) {
  if (model instanceof Gemini25Flash) {
    return "gemini-2.5-flash";
  } else if (model instanceof Gemini25Pro) {
    return "gemini-2.5-pro";
  } else if (model instanceof Gemini38Flash) {
    return "gemini-3.8-flash";
  } else if (model instanceof Gemini37Flash) {
    return "gemini-3.7-flash";
  } else if (model instanceof Gemini36Flash) {
    return "gemini-3.6-flash";
  } else if (model instanceof Gemini35Flash) {
    return "gemini-3.5-flash";
  } else if (model instanceof Gemini35FlashLite) {
    return "gemini-3.5-flash-lite";
  } else if (model instanceof Gemini31FlashLite) {
    return "gemini-3.1-flash-lite";
  } else {
    return "gemini-3.1-pro-preview";
  }
}

function bedrock_model_name(model) {
  if (model instanceof BedrockClaude37Sonnet) {
    return "eu.anthropic.claude-3-7-sonnet-20250219-v1:0";
  } else if (model instanceof BedrockClaudeSonnet4) {
    return "eu.anthropic.claude-sonnet-4-20250514-v1:0";
  } else if (model instanceof BedrockClaudeOpus45) {
    return "eu.anthropic.claude-opus-4-5-20251101-v1:0";
  } else if (model instanceof BedrockClaudeSonnet45) {
    return "eu.anthropic.claude-sonnet-4-5-20250929-v1:0";
  } else if (model instanceof BedrockClaudeHaiku45) {
    return "eu.anthropic.claude-haiku-4-5-20251001-v1:0";
  } else if (model instanceof BedrockClaudeSonnet46) {
    return "eu.anthropic.claude-sonnet-4-6";
  } else if (model instanceof BedrockClaudeOpus47) {
    return "eu.anthropic.claude-opus-4-7";
  } else if (model instanceof BedrockClaudeOpus48) {
    return "eu.anthropic.claude-opus-4-8";
  } else if (model instanceof BedrockClaudeOpus5) {
    return "eu.anthropic.claude-opus-5";
  } else if (model instanceof BedrockClaudeSonnet5) {
    return "eu.anthropic.claude-sonnet-5";
  } else {
    return "deepseek.v3-v1:0";
  }
}

function openai_model_name(model) {
  if (model instanceof Gpt4o) {
    return "gpt-4o";
  } else if (model instanceof Gpt41Nano) {
    return "gpt-4.1-nano";
  } else if (model instanceof Gpt41Mini) {
    return "gpt-4.1-mini";
  } else if (model instanceof Gpt41) {
    return "gpt-4.1";
  } else if (model instanceof Gpt5Nano) {
    return "gpt-5-nano";
  } else if (model instanceof Gpt5Mini) {
    return "gpt-5-mini";
  } else if (model instanceof Gpt5) {
    return "gpt-5";
  } else if (model instanceof Gpt5ChatLatest) {
    return "gpt-5-chat-latest";
  } else if (model instanceof Gpt51) {
    return "gpt-5.1";
  } else if (model instanceof Gpt51ChatLatest) {
    return "gpt-5.1-chat-latest";
  } else if (model instanceof Gpt52) {
    return "gpt-5.2";
  } else if (model instanceof Gpt52ChatLatest) {
    return "gpt-5.2-chat-latest";
  } else if (model instanceof Gpt54Nano) {
    return "gpt-5.4-nano";
  } else if (model instanceof Gpt55) {
    return "gpt-5.5";
  } else if (model instanceof Gpt56Sol) {
    return "gpt-5.6-sol";
  } else if (model instanceof Gpt56Terra) {
    return "gpt-5.6-terra";
  } else if (model instanceof Gpt56Luna) {
    return "gpt-5.6-luna";
  } else if (model instanceof Gpt6Astra) {
    return "gpt-6-astra";
  } else if (model instanceof Gpt6Sol) {
    return "gpt-6-sol";
  } else {
    return "gpt-6-luna";
  }
}

function azure_openai_model_name(model) {
  if (model instanceof AzureGpt4o) {
    return "azure-gpt-4o";
  } else {
    return "gpt-4.1-mini";
  }
}

function azure_ai_model_name(model) {
  if (model instanceof AzureGpt5Chat) {
    return "gpt-5-chat";
  } else if (model instanceof AzureGpt51Chat) {
    return "gpt-5.1-chat";
  } else if (model instanceof AzureGpt5Nano) {
    return "gpt-5-nano";
  } else {
    return "Llama-4-Scout-17B-16E-Instruct";
  }
}

export function model_from_string(name) {
  if (name.startsWith("azure_ai/")) {
    let rest = name.slice(9);
    return find_model(
      rest,
      azure_ai_models,
      azure_ai_model_name,
      (var0) => { return new AzureAi(var0); },
    );
  } else if (name.startsWith("azure/")) {
    let rest = name.slice(6);
    return find_model(
      rest,
      azure_openai_models,
      azure_openai_model_name,
      (var0) => { return new AzureOpenAi(var0); },
    );
  } else if (name.startsWith("openai/")) {
    let rest = name.slice(7);
    return find_model(
      rest,
      openai_models,
      openai_model_name,
      (var0) => { return new OpenAi(var0); },
    );
  } else if (name.startsWith("bedrock/")) {
    let rest = name.slice(8);
    return find_model(
      rest,
      bedrock_models,
      bedrock_model_name,
      (var0) => { return new Bedrock(var0); },
    );
  } else if (name.startsWith("gemini/")) {
    let rest = name.slice(7);
    return find_model(
      rest,
      gemini_models,
      gemini_model_name,
      (var0) => { return new Gemini(var0); },
    );
  } else {
    return find_model(
      name,
      anthropic_models,
      anthropic_model_name,
      (var0) => { return new Anthropic(var0); },
    );
  }
}

export function model_decoder() {
  return $decode.then$(
    $decode.string,
    (name) => {
      let $ = model_from_string(name);
      if ($ instanceof Ok) {
        let model = $[0];
        return $decode.success(model);
      } else {
        return $decode.failure(new OpenAi(new Gpt41()), "ModelType");
      }
    },
  );
}

export function score_prompt_decoder() {
  return $decode.then$(
    $decode.string,
    (score_prompt) => {
      let expected = "compute_score_v1 | compute_score_v2";
      if (score_prompt === "compute_score_v1") {
        return $decode.success(new ComputeScoreV1());
      } else if (score_prompt === "compute_score_v2") {
        return $decode.success(new ComputeScoreV2());
      } else {
        return $decode.failure(new ComputeScoreV1(), expected);
      }
    },
  );
}

function verbosity_decoder() {
  return $decode.then$(
    $decode.string,
    (value) => {
      if (value === "low") {
        return $decode.success(new VerbosityLow());
      } else if (value === "medium") {
        return $decode.success(new VerbosityMedium());
      } else if (value === "high") {
        return $decode.success(new VerbosityHigh());
      } else {
        return $decode.failure(new VerbosityLow(), "low | medium | high");
      }
    },
  );
}

function reasoning_effort_decoder() {
  return $decode.then$(
    $decode.string,
    (value) => {
      if (value === "low") {
        return $decode.success(new ReasoningLow());
      } else if (value === "medium") {
        return $decode.success(new ReasoningMedium());
      } else if (value === "high") {
        return $decode.success(new ReasoningHigh());
      } else {
        return $decode.failure(new ReasoningLow(), "low | medium | high");
      }
    },
  );
}

function what_to_return_decoder() {
  return $decode.then$(
    $decode.string,
    (value) => {
      if (value === "off") {
        return $decode.success(new WhatToReturnOff());
      } else if (value === "json") {
        return $decode.success(new ReturnJson());
      } else if (value === "text") {
        return $decode.success(new ReturnText());
      } else {
        return $decode.failure(new WhatToReturnOff(), "off | json | text");
      }
    },
  );
}

function redirect_decoder() {
  return $decode.then$(
    $decode.string,
    (value) => {
      if (value === "off") {
        return $decode.success(new RedirectOff());
      } else if (value === "default") {
        return $decode.success(new RedirectDefault());
      } else {
        return $decode.failure(new RedirectOff(), "off | default");
      }
    },
  );
}

function evidence_over_assertion_decoder() {
  return $decode.then$(
    $decode.string,
    (value) => {
      if (value === "off") {
        return $decode.success(new EvidenceOverAssertionOff());
      } else if (value === "default") {
        return $decode.success(new EvidenceOverAssertionDefault());
      } else {
        return $decode.failure(new EvidenceOverAssertionOff(), "off | default");
      }
    },
  );
}

function length_rule_decoder() {
  return $decode.then$(
    $decode.string,
    (value) => {
      if (value === "off") {
        return $decode.success(new LengthRuleOff());
      } else if (value === "category_based") {
        return $decode.success(new CategoryBased());
      } else if (value === "generalistic") {
        return $decode.success(new Generalistic());
      } else {
        return $decode.failure(
          new LengthRuleOff(),
          "off | category_based | generalistic",
        );
      }
    },
  );
}

function formatting_decoder() {
  return $decode.then$(
    $decode.string,
    (value) => {
      if (value === "off") {
        return $decode.success(new FormattingOff());
      } else if (value === "default") {
        return $decode.success(new FormattingDefault());
      } else {
        return $decode.failure(new FormattingOff(), "off | default");
      }
    },
  );
}

function repeat_question_decoder() {
  return $decode.then$(
    $decode.string,
    (value) => {
      if (value === "off") {
        return $decode.success(new RepeatQuestionOff());
      } else if (value === "repeat") {
        return $decode.success(new Repeat());
      } else if (value === "do_not_repeat") {
        return $decode.success(new DoNotRepeat());
      } else if (value === "do_no_repeat") {
        return $decode.success(new DoNotRepeat());
      } else if (value === "do_not_repeat_warm") {
        return $decode.success(new DoNotRepeatWarm());
      } else {
        return $decode.failure(
          new RepeatQuestionOff(),
          "off | repeat | do_not_repeat | do_not_repeat_warm",
        );
      }
    },
  );
}

function tone_style_decoder() {
  return $decode.then$(
    $decode.string,
    (value) => {
      if (value === "off") {
        return $decode.success(new ToneStyleOff());
      } else if (value === "default") {
        return $decode.success(new ToneStyleDefault());
      } else {
        return $decode.failure(new ToneStyleOff(), "off | default");
      }
    },
  );
}

function tone_voice_decoder() {
  return $decode.then$(
    $decode.string,
    (value) => {
      if (value === "off") {
        return $decode.success(new ToneVoiceOff());
      } else if (value === "customer") {
        return $decode.success(new ToneVoiceCustomer());
      } else if (value === "engaged") {
        return $decode.success(new ToneVoiceEngaged());
      } else if (value === "generic") {
        return $decode.success(new ToneVoiceGeneric());
      } else {
        return $decode.failure(
          new ToneVoiceOff(),
          "off | customer | engaged | generic",
        );
      }
    },
  );
}

function approach_decoder() {
  return $decode.then$(
    $decode.string,
    (value) => {
      if (value === "off") {
        return $decode.success(new ApproachOff());
      } else if (value === "default") {
        return $decode.success(new ApproachDefault());
      } else {
        return $decode.failure(new ApproachOff(), "off | default");
      }
    },
  );
}

function entity_mismatch_decoder() {
  return $decode.then$(
    $decode.string,
    (value) => {
      if (value === "off") {
        return $decode.success(new EntityMismatchOff());
      } else if (value === "default") {
        return $decode.success(new EntityMismatchDefault());
      } else {
        return $decode.failure(new EntityMismatchOff(), "off | default");
      }
    },
  );
}

function role_decoder() {
  return $decode.then$(
    $decode.string,
    (value) => {
      if (value === "off") {
        return $decode.success(new RoleOff());
      } else if (value === "rfp_expert") {
        return $decode.success(new RoleRfpExpert());
      } else {
        return $decode.failure(new RoleOff(), "off | rfp_expert");
      }
    },
  );
}

function rag_modular_config_decoder() {
  return $decode.field(
    "role",
    role_decoder(),
    (role) => {
      return $decode.field(
        "entity_mismatch",
        entity_mismatch_decoder(),
        (entity_mismatch) => {
          return $decode.field(
            "approach",
            approach_decoder(),
            (approach) => {
              return $decode.field(
                "tone_voice",
                tone_voice_decoder(),
                (tone_voice) => {
                  return $decode.field(
                    "tone_style",
                    tone_style_decoder(),
                    (tone_style) => {
                      return $decode.field(
                        "repeat_or_not_question",
                        repeat_question_decoder(),
                        (repeat_or_not_question) => {
                          return $decode.field(
                            "formatting",
                            formatting_decoder(),
                            (formatting) => {
                              return $decode.field(
                                "length",
                                length_rule_decoder(),
                                (length) => {
                                  return $decode.field(
                                    "evidence_over_assertion",
                                    evidence_over_assertion_decoder(),
                                    (evidence_over_assertion) => {
                                      return $decode.field(
                                        "redirect",
                                        redirect_decoder(),
                                        (redirect) => {
                                          return $decode.field(
                                            "what_to_return",
                                            what_to_return_decoder(),
                                            (what_to_return) => {
                                              return $decode.success(
                                                new RagModularConfig(
                                                  role,
                                                  entity_mismatch,
                                                  approach,
                                                  tone_voice,
                                                  tone_style,
                                                  repeat_or_not_question,
                                                  formatting,
                                                  length,
                                                  evidence_over_assertion,
                                                  redirect,
                                                  what_to_return,
                                                ),
                                              );
                                            },
                                          );
                                        },
                                      );
                                    },
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function rag_prompt_decoder() {
  return $decode.then$(
    $decode.string,
    (rag_prompt) => {
      let expected = "question_answer | question_answer_v2 | assess_requirement | assess_requirement_v2 | modular";
      if (rag_prompt === "question_answer") {
        return $decode.success(new QuestionAnswerV1());
      } else if (rag_prompt === "question_answer_v2") {
        return $decode.success(new QuestionAnswerV2());
      } else if (rag_prompt === "assess_requirement") {
        return $decode.success(new AssessRequirementV1());
      } else if (rag_prompt === "assess_requirement_v2") {
        return $decode.success(new AssessRequirementV2());
      } else if (rag_prompt === "modular") {
        return $decode.success(new Modular());
      } else {
        return $decode.failure(new QuestionAnswerV1(), expected);
      }
    },
  );
}

function models_config_decoder() {
  return $decode.field(
    "rag",
    model_decoder(),
    (rag) => {
      return $decode.field(
        "rag_temperature",
        $decrypt.float(),
        (rag_temperature) => {
          return $decode.field(
            "rag_prompt",
            rag_prompt_decoder(),
            (rag_prompt) => {
              return $decrypt.optional_field(
                "rag_modular_config",
                rag_modular_config_decoder(),
                (rag_modular_config) => {
                  return $decrypt.optional_field(
                    "rag_structured_call",
                    $decode.bool,
                    (rag_structured_call) => {
                      let rag_structured_call$1 = $option.unwrap(
                        rag_structured_call,
                        true,
                      );
                      return $decrypt.optional_field(
                        "run_style_prompt",
                        $decode.bool,
                        (run_style_prompt) => {
                          return $decrypt.optional_field(
                            "convert_markdown_to_html",
                            $decode.bool,
                            (convert_markdown_to_html) => {
                              let convert_markdown_to_html$1 = $option.unwrap(
                                convert_markdown_to_html,
                                false,
                              );
                              let run_style_prompt$1 = $option.unwrap(
                                run_style_prompt,
                                true,
                              );
                              return $decrypt.optional_field(
                                "reasoning_effort",
                                reasoning_effort_decoder(),
                                (reasoning_effort) => {
                                  return $decrypt.optional_field(
                                    "verbosity",
                                    verbosity_decoder(),
                                    (verbosity) => {
                                      return $decode.field(
                                        "compute_score_prompt",
                                        score_prompt_decoder(),
                                        (compute_score_prompt) => {
                                          return $decode.field(
                                            "style_2",
                                            model_decoder(),
                                            (style_2) => {
                                              return $decode.field(
                                                "summary",
                                                model_decoder(),
                                                (summary) => {
                                                  return $decode.field(
                                                    "classifier",
                                                    model_decoder(),
                                                    (classifier) => {
                                                      return $decode.field(
                                                        "translate_model",
                                                        model_decoder(),
                                                        (translate_model) => {
                                                          return $decode.field(
                                                            "conversational_model",
                                                            model_decoder(),
                                                            (
                                                                conversational_model
                                                              ) => {
                                                              return $decode.field(
                                                                "eval_model",
                                                                model_decoder(),
                                                                (eval_model) => {
                                                                  return $decode.field(
                                                                    "website_scrapping_model",
                                                                    model_decoder(),
                                                                    (
                                                                        website_scrapping_model
                                                                      ) => {
                                                                      return $decode.field(
                                                                        "default_model",
                                                                        model_decoder(),
                                                                        (
                                                                            default_model
                                                                          ) => {
                                                                          return $decode.field(
                                                                            "search_model",
                                                                            model_decoder(),
                                                                            (
                                                                                search_model
                                                                              ) => {
                                                                              return $decrypt.optional_field(
                                                                                "rows_columns_detection_model",
                                                                                model_decoder(),
                                                                                (
                                                                                    rows_columns_detection_model
                                                                                  ) => {
                                                                                  let rows_columns_detection_model$1 = $option.unwrap(
                                                                                    rows_columns_detection_model,
                                                                                    new OpenAi(
                                                                                      new Gpt6Sol(),
                                                                                    ),
                                                                                  );
                                                                                  return $decrypt.optional_field(
                                                                                    "advanced_cell_detection_model",
                                                                                    model_decoder(),
                                                                                    (
                                                                                        advanced_cell_detection_model
                                                                                      ) => {
                                                                                      let advanced_cell_detection_model$1 = $option.unwrap(
                                                                                        advanced_cell_detection_model,
                                                                                        new OpenAi(
                                                                                          new Gpt51(),
                                                                                        ),
                                                                                      );
                                                                                      return $decrypt.optional_field(
                                                                                        "docx_question_detection_model",
                                                                                        model_decoder(),
                                                                                        (
                                                                                            docx_question_detection_model
                                                                                          ) => {
                                                                                          let docx_question_detection_model$1 = $option.unwrap(
                                                                                            docx_question_detection_model,
                                                                                            new OpenAi(
                                                                                              new Gpt55(),
                                                                                            ),
                                                                                          );
                                                                                          return $decrypt.optional_field(
                                                                                            "website_capture_model",
                                                                                            model_decoder(),
                                                                                            (
                                                                                                website_capture_model
                                                                                              ) => {
                                                                                              let website_capture_model$1 = $option.unwrap(
                                                                                                website_capture_model,
                                                                                                new OpenAi(
                                                                                                  new Gpt6Luna(),
                                                                                                ),
                                                                                              );
                                                                                              return $decrypt.optional_field(
                                                                                                "answer_instruction_model",
                                                                                                model_decoder(),
                                                                                                (
                                                                                                    answer_instruction_model
                                                                                                  ) => {
                                                                                                  let answer_instruction_model$1 = $option.unwrap(
                                                                                                    answer_instruction_model,
                                                                                                    new OpenAi(
                                                                                                      new Gpt56Luna(),
                                                                                                    ),
                                                                                                  );
                                                                                                  return $decrypt.optional_field(
                                                                                                    "agentic_loop_driver_model",
                                                                                                    model_decoder(),
                                                                                                    (
                                                                                                        agentic_loop_driver_model
                                                                                                      ) => {
                                                                                                      let agentic_loop_driver_model$1 = $option.unwrap(
                                                                                                        agentic_loop_driver_model,
                                                                                                        new OpenAi(
                                                                                                          new Gpt6Luna(),
                                                                                                        ),
                                                                                                      );
                                                                                                      return $decode.field(
                                                                                                        "default_fallback_models",
                                                                                                        $decode.list(
                                                                                                          model_decoder(),
                                                                                                        ),
                                                                                                        (
                                                                                                            default_fallback_models
                                                                                                          ) => {
                                                                                                          return $decode.success(
                                                                                                            new ModelsConfig(
                                                                                                              rag,
                                                                                                              rag_temperature,
                                                                                                              rag_prompt,
                                                                                                              rag_modular_config,
                                                                                                              rag_structured_call$1,
                                                                                                              run_style_prompt$1,
                                                                                                              convert_markdown_to_html$1,
                                                                                                              reasoning_effort,
                                                                                                              verbosity,
                                                                                                              compute_score_prompt,
                                                                                                              style_2,
                                                                                                              summary,
                                                                                                              classifier,
                                                                                                              translate_model,
                                                                                                              conversational_model,
                                                                                                              eval_model,
                                                                                                              default_model,
                                                                                                              website_scrapping_model,
                                                                                                              search_model,
                                                                                                              rows_columns_detection_model$1,
                                                                                                              advanced_cell_detection_model$1,
                                                                                                              docx_question_detection_model$1,
                                                                                                              website_capture_model$1,
                                                                                                              answer_instruction_model$1,
                                                                                                              agentic_loop_driver_model$1,
                                                                                                              default_fallback_models,
                                                                                                            ),
                                                                                                          );
                                                                                                        },
                                                                                                      );
                                                                                                    },
                                                                                                  );
                                                                                                },
                                                                                              );
                                                                                            },
                                                                                          );
                                                                                        },
                                                                                      );
                                                                                    },
                                                                                  );
                                                                                },
                                                                              );
                                                                            },
                                                                          );
                                                                        },
                                                                      );
                                                                    },
                                                                  );
                                                                },
                                                              );
                                                            },
                                                          );
                                                        },
                                                      );
                                                    },
                                                  );
                                                },
                                              );
                                            },
                                          );
                                        },
                                      );
                                    },
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

function llm_config_decoder() {
  return $decode.field(
    "limit",
    $decode.int,
    (limit) => { return $decode.success(new LLMConfig(limit)); },
  );
}

export function ai_system_decoder() {
  return $decode.then$(
    $decode.string,
    (ai_system) => {
      let expected = "advanced_rag | agentic_rag";
      if (ai_system === "advanced_rag") {
        return $decode.success(new AdvancedRag());
      } else if (ai_system === "agentic_rag") {
        return $decode.success(new AgenticRag());
      } else if (ai_system === "naive_rag") {
        return $decode.success(new AdvancedRag());
      } else if (ai_system === "naive_raag") {
        return $decode.success(new AdvancedRag());
      } else if (ai_system === "llm_enhanced_vector_search") {
        return $decode.success(new AdvancedRag());
      } else {
        return $decode.failure(new AdvancedRag(), expected);
      }
    },
  );
}

export function config_decoder() {
  let style_guidelines = $decode.optional($decode.string);
  return $decode.field(
    "style_guidelines",
    style_guidelines,
    (style_guidelines) => {
      return $decode.field(
        "ai_system",
        ai_system_decoder(),
        (ai_system) => {
          return $decode.field(
            "llm_config",
            llm_config_decoder(),
            (llm_config) => {
              return $decode.field(
                "models_config",
                models_config_decoder(),
                (models_config) => {
                  return $decode.field(
                    "query_config",
                    query_config_decoder(),
                    (query_config) => {
                      return $decode.field(
                        "retriever_config",
                        retriever_config_decoder(),
                        (retriever_config) => {
                          let pii_vocabulary = $decode.list($decode.string);
                          return $decode.field(
                            "pii_vocabulary",
                            pii_vocabulary,
                            (pii_vocabulary) => {
                              return $decrypt.optional_field(
                                "context_window",
                                context_window_decoder(),
                                (context_window) => {
                                  return $decrypt.optional_field(
                                    "llm_judge_in_the_loop",
                                    $decode.bool,
                                    (llm_judge_in_the_loop) => {
                                      return $decrypt.optional_field(
                                        "website_prompt_config",
                                        website_prompt_config_decoder(),
                                        (website_prompt_config) => {
                                          let website_prompt_config$1 = $option.unwrap(
                                            website_prompt_config,
                                            default_website_prompt_config(),
                                          );
                                          let context_window$1 = $option.unwrap(
                                            context_window,
                                            new ContextWindow(
                                              default_deactivated_context_window_lookback,
                                              default_deactivated_context_window_lookahead,
                                            ),
                                          );
                                          let llm_judge_in_the_loop$1 = $option.unwrap(
                                            llm_judge_in_the_loop,
                                            false,
                                          );
                                          return $decrypt.optional_field(
                                            "read_collection_variant",
                                            $weaviate.collection_variant_decoder(),
                                            (read_collection_variant) => {
                                              let read_collection_variant$1 = $option.unwrap(
                                                read_collection_variant,
                                                new $weaviate.Base(),
                                              );
                                              return $decrypt.optional_field(
                                                "write_collection_variant",
                                                $weaviate.collection_variant_decoder(),
                                                (write_collection_variant) => {
                                                  let write_collection_variant$1 = $option.unwrap(
                                                    write_collection_variant,
                                                    new $weaviate.Base(),
                                                  );
                                                  return $decrypt.optional_field(
                                                    "prev_write_collection_variant",
                                                    $weaviate.collection_variant_decoder(),
                                                    (
                                                        prev_write_collection_variant
                                                      ) => {
                                                      return $decode.success(
                                                        new Config(
                                                          style_guidelines,
                                                          ai_system,
                                                          llm_config,
                                                          models_config,
                                                          query_config,
                                                          retriever_config,
                                                          pii_vocabulary,
                                                          context_window$1,
                                                          llm_judge_in_the_loop$1,
                                                          website_prompt_config$1,
                                                          read_collection_variant$1,
                                                          write_collection_variant$1,
                                                          prev_write_collection_variant,
                                                        ),
                                                      );
                                                    },
                                                  );
                                                },
                                              );
                                            },
                                          );
                                        },
                                      );
                                    },
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function decoder() {
  return $decode.field(
    "org_id",
    $decode.string,
    (org_id) => {
      return $decode.field(
        "config",
        $decrypt.json(config_decoder()),
        (config) => { return $decode.success(new AiConfig(org_id, config)); },
      );
    },
  );
}

function encode_website_prompt_config(config) {
  return $json.object(
    toList([
      ["labels_instructions", $json.string(config.labels_instructions)],
      ["what_to_ignore", $json.string(config.what_to_ignore)],
      [
        "breadcrumbs_instructions",
        $json.string(config.breadcrumbs_instructions),
      ],
    ]),
  );
}

function encode_context_window(context_window) {
  return $json.object(
    toList([
      ["lookback", $json.int(context_window.lookback)],
      ["lookahead", $json.int(context_window.lookahead)],
    ]),
  );
}

function encode_retriever_option_type(option) {
  if (option instanceof Hybrid) {
    return $json.string("hybrid");
  } else if (option instanceof Rerank) {
    return $json.string("rerank");
  } else {
    return $json.string("fusion");
  }
}

function encode_retriever_config(retriever_config) {
  return $json.object(
    toList([["option", encode_retriever_option_type(retriever_config.option)]]),
  );
}

function encode_agentic_retrieval_config(agentic_retrieval_config) {
  return $json.object(
    toList([
      ["max_iterations", $json.int(agentic_retrieval_config.max_iterations)],
      ["max_docs", $json.int(agentic_retrieval_config.max_docs)],
      ["max_queries", $json.int(agentic_retrieval_config.max_queries)],
    ]),
  );
}

function encode_query_config(query_config) {
  return $json.object(
    toList([
      ["limit", $json.int(query_config.limit)],
      ["alpha", $json.float(query_config.alpha)],
      ["parent_lookup", $json.bool(query_config.parent_lookup)],
      ["hyde", $json.bool(query_config.hyde)],
      ["extract_question", $json.bool(query_config.extract_question)],
      ["minimal_score", $json.float(query_config.minimal_score)],
      ["split_query", $json.bool(query_config.split_query)],
      ["use_dates", $json.bool(query_config.use_dates)],
      [
        "agentic_retrieval",
        $json.nullable(
          query_config.agentic_retrieval,
          encode_agentic_retrieval_config,
        ),
      ],
    ]),
  );
}

export function model_to_string(model) {
  if (model instanceof OpenAi) {
    let model$1 = model[0];
    return "openai/" + openai_model_name(model$1);
  } else if (model instanceof AzureOpenAi) {
    let model$1 = model[0];
    return "azure/" + azure_openai_model_name(model$1);
  } else if (model instanceof AzureAi) {
    let model$1 = model[0];
    return "azure_ai/" + azure_ai_model_name(model$1);
  } else if (model instanceof Anthropic) {
    let model$1 = model[0];
    return anthropic_model_name(model$1);
  } else if (model instanceof Bedrock) {
    let model$1 = model[0];
    return "bedrock/" + bedrock_model_name(model$1);
  } else {
    let model$1 = model[0];
    return "gemini/" + gemini_model_name(model$1);
  }
}

export function encode_model(model) {
  let _pipe = model;
  let _pipe$1 = model_to_string(_pipe);
  return $json.string(_pipe$1);
}

function encode_score_prompt(score_prompt) {
  if (score_prompt instanceof ComputeScoreV1) {
    return $json.string("compute_score_v1");
  } else {
    return $json.string("compute_score_v2");
  }
}

function encode_verbosity(verbosity) {
  if (verbosity instanceof VerbosityLow) {
    return $json.string("low");
  } else if (verbosity instanceof VerbosityMedium) {
    return $json.string("medium");
  } else {
    return $json.string("high");
  }
}

function encode_reasoning_effort(reasoning_effort) {
  if (reasoning_effort instanceof ReasoningLow) {
    return $json.string("low");
  } else if (reasoning_effort instanceof ReasoningMedium) {
    return $json.string("medium");
  } else {
    return $json.string("high");
  }
}

function encode_what_to_return(what_to_return) {
  if (what_to_return instanceof WhatToReturnOff) {
    return $json.string("off");
  } else if (what_to_return instanceof ReturnJson) {
    return $json.string("json");
  } else {
    return $json.string("text");
  }
}

function encode_redirect(redirect) {
  if (redirect instanceof RedirectOff) {
    return $json.string("off");
  } else {
    return $json.string("default");
  }
}

function encode_evidence_over_assertion(evidence_over_assertion) {
  if (evidence_over_assertion instanceof EvidenceOverAssertionOff) {
    return $json.string("off");
  } else {
    return $json.string("default");
  }
}

function encode_length_rule(length_rule) {
  if (length_rule instanceof LengthRuleOff) {
    return $json.string("off");
  } else if (length_rule instanceof CategoryBased) {
    return $json.string("category_based");
  } else {
    return $json.string("generalistic");
  }
}

function encode_formatting(formatting) {
  if (formatting instanceof FormattingOff) {
    return $json.string("off");
  } else {
    return $json.string("default");
  }
}

function encode_repeat_question(repeat_question) {
  if (repeat_question instanceof RepeatQuestionOff) {
    return $json.string("off");
  } else if (repeat_question instanceof Repeat) {
    return $json.string("repeat");
  } else if (repeat_question instanceof DoNotRepeat) {
    return $json.string("do_not_repeat");
  } else {
    return $json.string("do_not_repeat_warm");
  }
}

function encode_tone_style(tone_style) {
  if (tone_style instanceof ToneStyleOff) {
    return $json.string("off");
  } else {
    return $json.string("default");
  }
}

function encode_tone_voice(tone_voice) {
  if (tone_voice instanceof ToneVoiceOff) {
    return $json.string("off");
  } else if (tone_voice instanceof ToneVoiceCustomer) {
    return $json.string("customer");
  } else if (tone_voice instanceof ToneVoiceEngaged) {
    return $json.string("engaged");
  } else {
    return $json.string("generic");
  }
}

function encode_approach(approach) {
  if (approach instanceof ApproachOff) {
    return $json.string("off");
  } else {
    return $json.string("default");
  }
}

function encode_entity_mismatch(entity_mismatch) {
  if (entity_mismatch instanceof EntityMismatchOff) {
    return $json.string("off");
  } else {
    return $json.string("default");
  }
}

function encode_role(role) {
  if (role instanceof RoleOff) {
    return $json.string("off");
  } else {
    return $json.string("rfp_expert");
  }
}

function encode_rag_modular_config(config) {
  return $json.object(
    toList([
      ["role", encode_role(config.role)],
      ["entity_mismatch", encode_entity_mismatch(config.entity_mismatch)],
      ["approach", encode_approach(config.approach)],
      ["tone_voice", encode_tone_voice(config.tone_voice)],
      ["tone_style", encode_tone_style(config.tone_style)],
      [
        "repeat_or_not_question",
        encode_repeat_question(config.repeat_or_not_question),
      ],
      ["formatting", encode_formatting(config.formatting)],
      ["length", encode_length_rule(config.length)],
      [
        "evidence_over_assertion",
        encode_evidence_over_assertion(config.evidence_over_assertion),
      ],
      ["redirect", encode_redirect(config.redirect)],
      ["what_to_return", encode_what_to_return(config.what_to_return)],
    ]),
  );
}

function encode_rag_prompt(rag_prompt) {
  if (rag_prompt instanceof QuestionAnswerV1) {
    return $json.string("question_answer");
  } else if (rag_prompt instanceof QuestionAnswerV2) {
    return $json.string("question_answer_v2");
  } else if (rag_prompt instanceof AssessRequirementV1) {
    return $json.string("assess_requirement");
  } else if (rag_prompt instanceof AssessRequirementV2) {
    return $json.string("assess_requirement_v2");
  } else {
    return $json.string("modular");
  }
}

function encode_models_config(models_config) {
  return $json.object(
    toList([
      ["rag", encode_model(models_config.rag)],
      ["rag_temperature", $json.float(models_config.rag_temperature)],
      ["rag_prompt", encode_rag_prompt(models_config.rag_prompt)],
      [
        "rag_modular_config",
        $json.nullable(
          models_config.rag_modular_config,
          encode_rag_modular_config,
        ),
      ],
      ["rag_structured_call", $json.bool(models_config.rag_structured_call)],
      ["run_style_prompt", $json.bool(models_config.run_style_prompt)],
      [
        "convert_markdown_to_html",
        $json.bool(models_config.convert_markdown_to_html),
      ],
      [
        "reasoning_effort",
        $json.nullable(models_config.reasoning_effort, encode_reasoning_effort),
      ],
      ["verbosity", $json.nullable(models_config.verbosity, encode_verbosity)],
      [
        "compute_score_prompt",
        encode_score_prompt(models_config.compute_score_prompt),
      ],
      ["style_2", encode_model(models_config.style_2)],
      ["summary", encode_model(models_config.summary)],
      ["classifier", encode_model(models_config.classifier)],
      ["translate_model", encode_model(models_config.translate_model)],
      ["conversational_model", encode_model(models_config.conversational_model)],
      ["eval_model", encode_model(models_config.eval_model)],
      ["default_model", encode_model(models_config.default_model)],
      [
        "website_scrapping_model",
        encode_model(models_config.website_scrapping_model),
      ],
      ["search_model", encode_model(models_config.search_model)],
      [
        "rows_columns_detection_model",
        encode_model(models_config.rows_columns_detection_model),
      ],
      [
        "advanced_cell_detection_model",
        encode_model(models_config.advanced_cell_detection_model),
      ],
      [
        "docx_question_detection_model",
        encode_model(models_config.docx_question_detection_model),
      ],
      [
        "website_capture_model",
        encode_model(models_config.website_capture_model),
      ],
      [
        "answer_instruction_model",
        encode_model(models_config.answer_instruction_model),
      ],
      [
        "agentic_loop_driver_model",
        encode_model(models_config.agentic_loop_driver_model),
      ],
      [
        "default_fallback_models",
        $json.array(models_config.default_fallback_models, encode_model),
      ],
    ]),
  );
}

function encode_llm_config(llm_config) {
  return $json.object(toList([["limit", $json.int(llm_config.limit)]]));
}

function encode_ai_system(ai_system) {
  if (ai_system instanceof AdvancedRag) {
    return $json.string("advanced_rag");
  } else {
    return $json.string("agentic_rag");
  }
}

export function encode_config(config) {
  return $json.object(
    toList([
      [
        "style_guidelines",
        $json.nullable(config.style_guidelines, $json.string),
      ],
      ["ai_system", encode_ai_system(config.ai_system)],
      ["llm_config", encode_llm_config(config.llm_config)],
      ["models_config", encode_models_config(config.models_config)],
      ["query_config", encode_query_config(config.query_config)],
      ["retriever_config", encode_retriever_config(config.retriever_config)],
      ["pii_vocabulary", $json.array(config.pii_vocabulary, $json.string)],
      ["context_window", encode_context_window(config.context_window)],
      ["llm_judge_in_the_loop", $json.bool(config.llm_judge_in_the_loop)],
      [
        "website_prompt_config",
        encode_website_prompt_config(config.website_prompt_config),
      ],
      [
        "read_collection_variant",
        $weaviate.encode_collection_variant(config.read_collection_variant),
      ],
      [
        "write_collection_variant",
        $weaviate.encode_collection_variant(config.write_collection_variant),
      ],
      [
        "prev_write_collection_variant",
        $json.nullable(
          config.prev_write_collection_variant,
          $weaviate.encode_collection_variant,
        ),
      ],
    ]),
  );
}

export function encode(ai_config) {
  return $json.object(
    toList([
      ["org_id", $json.string(ai_config.org_id)],
      ["config", encode_config(ai_config.config)],
    ]),
  );
}

export function provider_name(model) {
  if (model instanceof OpenAi) {
    return "OpenAI";
  } else if (model instanceof AzureOpenAi) {
    return "Azure OpenAI";
  } else if (model instanceof AzureAi) {
    return "Azure AI";
  } else if (model instanceof Anthropic) {
    return "Anthropic";
  } else if (model instanceof Bedrock) {
    return "Bedrock";
  } else {
    return "Gemini";
  }
}

export function model_for(models_config, field) {
  if (field instanceof Rag) {
    return models_config.rag;
  } else if (field instanceof Style2) {
    return models_config.style_2;
  } else if (field instanceof Summary) {
    return models_config.summary;
  } else if (field instanceof Classifier) {
    return models_config.classifier;
  } else if (field instanceof TranslateModel) {
    return models_config.translate_model;
  } else if (field instanceof ConversationalModel) {
    return models_config.conversational_model;
  } else if (field instanceof EvalModel) {
    return models_config.eval_model;
  } else if (field instanceof DefaultModel) {
    return models_config.default_model;
  } else if (field instanceof WebsiteScrappingModel) {
    return models_config.website_scrapping_model;
  } else if (field instanceof SearchModel) {
    return models_config.search_model;
  } else if (field instanceof RowsColumnsDetectionModel) {
    return models_config.rows_columns_detection_model;
  } else if (field instanceof AdvancedCellDetectionModel) {
    return models_config.advanced_cell_detection_model;
  } else if (field instanceof DocxQuestionDetectionModel) {
    return models_config.docx_question_detection_model;
  } else if (field instanceof WebsiteCaptureModel) {
    return models_config.website_capture_model;
  } else if (field instanceof AnswerInstructionModel) {
    return models_config.answer_instruction_model;
  } else {
    return models_config.agentic_loop_driver_model;
  }
}

/**
 * The field's key in the stored `models_config` JSON.
 */
export function models_config_field_to_string(field) {
  if (field instanceof Rag) {
    return "rag";
  } else if (field instanceof Style2) {
    return "style_2";
  } else if (field instanceof Summary) {
    return "summary";
  } else if (field instanceof Classifier) {
    return "classifier";
  } else if (field instanceof TranslateModel) {
    return "translate_model";
  } else if (field instanceof ConversationalModel) {
    return "conversational_model";
  } else if (field instanceof EvalModel) {
    return "eval_model";
  } else if (field instanceof DefaultModel) {
    return "default_model";
  } else if (field instanceof WebsiteScrappingModel) {
    return "website_scrapping_model";
  } else if (field instanceof SearchModel) {
    return "search_model";
  } else if (field instanceof RowsColumnsDetectionModel) {
    return "rows_columns_detection_model";
  } else if (field instanceof AdvancedCellDetectionModel) {
    return "advanced_cell_detection_model";
  } else if (field instanceof DocxQuestionDetectionModel) {
    return "docx_question_detection_model";
  } else if (field instanceof WebsiteCaptureModel) {
    return "website_capture_model";
  } else if (field instanceof AnswerInstructionModel) {
    return "answer_instruction_model";
  } else {
    return "agentic_loop_driver_model";
  }
}

export function models_config_field_decoder() {
  return $decode.then$(
    $decode.string,
    (key) => {
      let $ = $list.find(
        models_config_fields,
        (field) => { return models_config_field_to_string(field) === key; },
      );
      if ($ instanceof Ok) {
        let field = $[0];
        return $decode.success(field);
      } else {
        return $decode.failure(new Rag(), "ModelsConfigField");
      }
    },
  );
}

function default_rag_modular_config() {
  return new RagModularConfig(
    new RoleRfpExpert(),
    new EntityMismatchDefault(),
    new ApproachDefault(),
    new ToneVoiceCustomer(),
    new ToneStyleDefault(),
    new DoNotRepeat(),
    new FormattingDefault(),
    new CategoryBased(),
    new EvidenceOverAssertionDefault(),
    new RedirectDefault(),
    new ReturnJson(),
  );
}

export function default_config() {
  let retriever_config = new RetrieverConfig(new Hybrid());
  let query_config = new QueryConfig(
    50,
    0.5,
    false,
    false,
    false,
    0.0,
    false,
    false,
    new Some(new AgenticRetrievalConfig(3, 10, 3)),
  );
  let models_config = new ModelsConfig(
    new OpenAi(new Gpt6Astra()),
    0.0,
    new Modular(),
    new Some(default_rag_modular_config()),
    true,
    true,
    true,
    new Some(new ReasoningLow()),
    new Some(new VerbosityLow()),
    new ComputeScoreV2(),
    new OpenAi(new Gpt6Luna()),
    new OpenAi(new Gpt6Luna()),
    new OpenAi(new Gpt6Luna()),
    new OpenAi(new Gpt6Luna()),
    new OpenAi(new Gpt6Luna()),
    new OpenAi(new Gpt51()),
    new OpenAi(new Gpt6Sol()),
    new OpenAi(new Gpt6Luna()),
    new OpenAi(new Gpt6Luna()),
    new OpenAi(new Gpt6Sol()),
    new OpenAi(new Gpt55()),
    new OpenAi(new Gpt55()),
    new OpenAi(new Gpt6Luna()),
    new OpenAi(new Gpt56Luna()),
    new OpenAi(new Gpt6Luna()),
    toList([new OpenAi(new Gpt6Luna())]),
  );
  let llm_config = new LLMConfig(10);
  return new Config(
    new Some(""),
    new AdvancedRag(),
    llm_config,
    models_config,
    query_config,
    retriever_config,
    toList([]),
    new ContextWindow(
      default_deactivated_context_window_lookback,
      default_deactivated_context_window_lookahead,
    ),
    false,
    default_website_prompt_config(),
    new $weaviate.Base(),
    new $weaviate.Base(),
    new $option.None(),
  );
}

export function set_website_prompt_config(ai_config, website_prompt_config) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        _record.models_config,
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_ai_system(ai_config, ai_system) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        ai_system,
        _record.llm_config,
        _record.models_config,
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_rag_prompt(ai_config, rag_prompt) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let _record$1 = ai_config.config.models_config;
          return new ModelsConfig(
            _record$1.rag,
            _record$1.rag_temperature,
            rag_prompt,
            _record$1.rag_modular_config,
            _record$1.rag_structured_call,
            _record$1.run_style_prompt,
            _record$1.convert_markdown_to_html,
            _record$1.reasoning_effort,
            _record$1.verbosity,
            _record$1.compute_score_prompt,
            _record$1.style_2,
            _record$1.summary,
            _record$1.classifier,
            _record$1.translate_model,
            _record$1.conversational_model,
            _record$1.eval_model,
            _record$1.default_model,
            _record$1.website_scrapping_model,
            _record$1.search_model,
            _record$1.rows_columns_detection_model,
            _record$1.advanced_cell_detection_model,
            _record$1.docx_question_detection_model,
            _record$1.website_capture_model,
            _record$1.answer_instruction_model,
            _record$1.agentic_loop_driver_model,
            _record$1.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_rag_model(ai_config, rag) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let models_config = ai_config.config.models_config;
          return new ModelsConfig(
            rag,
            models_config.rag_temperature,
            models_config.rag_prompt,
            models_config.rag_modular_config,
            models_config.rag_structured_call,
            models_config.run_style_prompt,
            models_config.convert_markdown_to_html,
            models_config.reasoning_effort,
            models_config.verbosity,
            models_config.compute_score_prompt,
            models_config.style_2,
            models_config.summary,
            models_config.classifier,
            models_config.translate_model,
            models_config.conversational_model,
            models_config.eval_model,
            models_config.default_model,
            models_config.website_scrapping_model,
            models_config.search_model,
            models_config.rows_columns_detection_model,
            models_config.advanced_cell_detection_model,
            models_config.docx_question_detection_model,
            models_config.website_capture_model,
            models_config.answer_instruction_model,
            models_config.agentic_loop_driver_model,
            models_config.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_search_model(ai_config, search_model) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let models_config = ai_config.config.models_config;
          return new ModelsConfig(
            models_config.rag,
            models_config.rag_temperature,
            models_config.rag_prompt,
            models_config.rag_modular_config,
            models_config.rag_structured_call,
            models_config.run_style_prompt,
            models_config.convert_markdown_to_html,
            models_config.reasoning_effort,
            models_config.verbosity,
            models_config.compute_score_prompt,
            models_config.style_2,
            models_config.summary,
            models_config.classifier,
            models_config.translate_model,
            models_config.conversational_model,
            models_config.eval_model,
            models_config.default_model,
            models_config.website_scrapping_model,
            search_model,
            models_config.rows_columns_detection_model,
            models_config.advanced_cell_detection_model,
            models_config.docx_question_detection_model,
            models_config.website_capture_model,
            models_config.answer_instruction_model,
            models_config.agentic_loop_driver_model,
            models_config.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_rows_columns_detection_model(
  ai_config,
  rows_columns_detection_model
) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let models_config = ai_config.config.models_config;
          return new ModelsConfig(
            models_config.rag,
            models_config.rag_temperature,
            models_config.rag_prompt,
            models_config.rag_modular_config,
            models_config.rag_structured_call,
            models_config.run_style_prompt,
            models_config.convert_markdown_to_html,
            models_config.reasoning_effort,
            models_config.verbosity,
            models_config.compute_score_prompt,
            models_config.style_2,
            models_config.summary,
            models_config.classifier,
            models_config.translate_model,
            models_config.conversational_model,
            models_config.eval_model,
            models_config.default_model,
            models_config.website_scrapping_model,
            models_config.search_model,
            rows_columns_detection_model,
            models_config.advanced_cell_detection_model,
            models_config.docx_question_detection_model,
            models_config.website_capture_model,
            models_config.answer_instruction_model,
            models_config.agentic_loop_driver_model,
            models_config.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_advanced_cell_detection_model(
  ai_config,
  advanced_cell_detection_model
) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let models_config = ai_config.config.models_config;
          return new ModelsConfig(
            models_config.rag,
            models_config.rag_temperature,
            models_config.rag_prompt,
            models_config.rag_modular_config,
            models_config.rag_structured_call,
            models_config.run_style_prompt,
            models_config.convert_markdown_to_html,
            models_config.reasoning_effort,
            models_config.verbosity,
            models_config.compute_score_prompt,
            models_config.style_2,
            models_config.summary,
            models_config.classifier,
            models_config.translate_model,
            models_config.conversational_model,
            models_config.eval_model,
            models_config.default_model,
            models_config.website_scrapping_model,
            models_config.search_model,
            models_config.rows_columns_detection_model,
            advanced_cell_detection_model,
            models_config.docx_question_detection_model,
            models_config.website_capture_model,
            models_config.answer_instruction_model,
            models_config.agentic_loop_driver_model,
            models_config.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_docx_question_detection_model(
  ai_config,
  docx_question_detection_model
) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let models_config = ai_config.config.models_config;
          return new ModelsConfig(
            models_config.rag,
            models_config.rag_temperature,
            models_config.rag_prompt,
            models_config.rag_modular_config,
            models_config.rag_structured_call,
            models_config.run_style_prompt,
            models_config.convert_markdown_to_html,
            models_config.reasoning_effort,
            models_config.verbosity,
            models_config.compute_score_prompt,
            models_config.style_2,
            models_config.summary,
            models_config.classifier,
            models_config.translate_model,
            models_config.conversational_model,
            models_config.eval_model,
            models_config.default_model,
            models_config.website_scrapping_model,
            models_config.search_model,
            models_config.rows_columns_detection_model,
            models_config.advanced_cell_detection_model,
            docx_question_detection_model,
            models_config.website_capture_model,
            models_config.answer_instruction_model,
            models_config.agentic_loop_driver_model,
            models_config.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_website_capture_model(ai_config, website_capture_model) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let models_config = ai_config.config.models_config;
          return new ModelsConfig(
            models_config.rag,
            models_config.rag_temperature,
            models_config.rag_prompt,
            models_config.rag_modular_config,
            models_config.rag_structured_call,
            models_config.run_style_prompt,
            models_config.convert_markdown_to_html,
            models_config.reasoning_effort,
            models_config.verbosity,
            models_config.compute_score_prompt,
            models_config.style_2,
            models_config.summary,
            models_config.classifier,
            models_config.translate_model,
            models_config.conversational_model,
            models_config.eval_model,
            models_config.default_model,
            models_config.website_scrapping_model,
            models_config.search_model,
            models_config.rows_columns_detection_model,
            models_config.advanced_cell_detection_model,
            models_config.docx_question_detection_model,
            website_capture_model,
            models_config.answer_instruction_model,
            models_config.agentic_loop_driver_model,
            models_config.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

/**
 * Model that writes the per-column answer instruction when a header is
 * confirmed at labelling time.
 */
export function set_answer_instruction_model(
  ai_config,
  answer_instruction_model
) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let models_config = ai_config.config.models_config;
          return new ModelsConfig(
            models_config.rag,
            models_config.rag_temperature,
            models_config.rag_prompt,
            models_config.rag_modular_config,
            models_config.rag_structured_call,
            models_config.run_style_prompt,
            models_config.convert_markdown_to_html,
            models_config.reasoning_effort,
            models_config.verbosity,
            models_config.compute_score_prompt,
            models_config.style_2,
            models_config.summary,
            models_config.classifier,
            models_config.translate_model,
            models_config.conversational_model,
            models_config.eval_model,
            models_config.default_model,
            models_config.website_scrapping_model,
            models_config.search_model,
            models_config.rows_columns_detection_model,
            models_config.advanced_cell_detection_model,
            models_config.docx_question_detection_model,
            models_config.website_capture_model,
            answer_instruction_model,
            models_config.agentic_loop_driver_model,
            models_config.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

/**
 * Model that drives the agentic RAG tool loop. The final answer is still
 * written by the rag model.
 */
export function set_agentic_loop_driver_model(
  ai_config,
  agentic_loop_driver_model
) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let models_config = ai_config.config.models_config;
          return new ModelsConfig(
            models_config.rag,
            models_config.rag_temperature,
            models_config.rag_prompt,
            models_config.rag_modular_config,
            models_config.rag_structured_call,
            models_config.run_style_prompt,
            models_config.convert_markdown_to_html,
            models_config.reasoning_effort,
            models_config.verbosity,
            models_config.compute_score_prompt,
            models_config.style_2,
            models_config.summary,
            models_config.classifier,
            models_config.translate_model,
            models_config.conversational_model,
            models_config.eval_model,
            models_config.default_model,
            models_config.website_scrapping_model,
            models_config.search_model,
            models_config.rows_columns_detection_model,
            models_config.advanced_cell_detection_model,
            models_config.docx_question_detection_model,
            models_config.website_capture_model,
            models_config.answer_instruction_model,
            agentic_loop_driver_model,
            models_config.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_score_prompt(ai_config, compute_score_prompt) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let models_config = ai_config.config.models_config;
          return new ModelsConfig(
            models_config.rag,
            models_config.rag_temperature,
            models_config.rag_prompt,
            models_config.rag_modular_config,
            models_config.rag_structured_call,
            models_config.run_style_prompt,
            models_config.convert_markdown_to_html,
            models_config.reasoning_effort,
            models_config.verbosity,
            compute_score_prompt,
            models_config.style_2,
            models_config.summary,
            models_config.classifier,
            models_config.translate_model,
            models_config.conversational_model,
            models_config.eval_model,
            models_config.default_model,
            models_config.website_scrapping_model,
            models_config.search_model,
            models_config.rows_columns_detection_model,
            models_config.advanced_cell_detection_model,
            models_config.docx_question_detection_model,
            models_config.website_capture_model,
            models_config.answer_instruction_model,
            models_config.agentic_loop_driver_model,
            models_config.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

function parse_float(value) {
  let number = $float.parse(value);
  return $result.lazy_or(
    number,
    () => {
      return $result.map(
        $int.parse(value),
        (number) => { return $int.to_float(number); },
      );
    },
  );
}

export function set_minimal_score(ai_config, minimal_score) {
  let $ = parse_float(minimal_score);
  if ($ instanceof Ok) {
    let minimal_score$1 = $[0];
    return new AiConfig(
      ai_config.org_id,
      (() => {
        let _record = ai_config.config;
        return new Config(
          _record.style_guidelines,
          _record.ai_system,
          _record.llm_config,
          _record.models_config,
          (() => {
            let _record$1 = ai_config.config.query_config;
            return new QueryConfig(
              _record$1.limit,
              _record$1.alpha,
              _record$1.parent_lookup,
              _record$1.hyde,
              _record$1.extract_question,
              minimal_score$1,
              _record$1.split_query,
              _record$1.use_dates,
              _record$1.agentic_retrieval,
            );
          })(),
          _record.retriever_config,
          _record.pii_vocabulary,
          _record.context_window,
          _record.llm_judge_in_the_loop,
          _record.website_prompt_config,
          _record.read_collection_variant,
          _record.write_collection_variant,
          _record.prev_write_collection_variant,
        );
      })(),
    );
  } else {
    return ai_config;
  }
}

export function toggle_split_query(ai_config) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        _record.models_config,
        (() => {
          let _record$1 = ai_config.config.query_config;
          return new QueryConfig(
            _record$1.limit,
            _record$1.alpha,
            _record$1.parent_lookup,
            _record$1.hyde,
            _record$1.extract_question,
            _record$1.minimal_score,
            !ai_config.config.query_config.split_query,
            _record$1.use_dates,
            _record$1.agentic_retrieval,
          );
        })(),
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function toggle_use_dates(ai_config) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        _record.models_config,
        (() => {
          let _record$1 = ai_config.config.query_config;
          return new QueryConfig(
            _record$1.limit,
            _record$1.alpha,
            _record$1.parent_lookup,
            _record$1.hyde,
            _record$1.extract_question,
            _record$1.minimal_score,
            _record$1.split_query,
            !ai_config.config.query_config.use_dates,
            _record$1.agentic_retrieval,
          );
        })(),
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_query_limit(ai_config, query_limit) {
  let $ = $int.parse(query_limit);
  if ($ instanceof Ok) {
    let limit = $[0];
    return new AiConfig(
      ai_config.org_id,
      (() => {
        let _record = ai_config.config;
        return new Config(
          _record.style_guidelines,
          _record.ai_system,
          _record.llm_config,
          _record.models_config,
          (() => {
            let _record$1 = ai_config.config.query_config;
            return new QueryConfig(
              limit,
              _record$1.alpha,
              _record$1.parent_lookup,
              _record$1.hyde,
              _record$1.extract_question,
              _record$1.minimal_score,
              _record$1.split_query,
              _record$1.use_dates,
              _record$1.agentic_retrieval,
            );
          })(),
          _record.retriever_config,
          _record.pii_vocabulary,
          _record.context_window,
          _record.llm_judge_in_the_loop,
          _record.website_prompt_config,
          _record.read_collection_variant,
          _record.write_collection_variant,
          _record.prev_write_collection_variant,
        );
      })(),
    );
  } else {
    return ai_config;
  }
}

export function set_llm_limit(ai_config, llm_limit) {
  let $ = $int.parse(llm_limit);
  if ($ instanceof Ok) {
    let limit = $[0];
    return new AiConfig(
      ai_config.org_id,
      (() => {
        let _record = ai_config.config;
        return new Config(
          _record.style_guidelines,
          _record.ai_system,
          new LLMConfig(limit),
          _record.models_config,
          _record.query_config,
          _record.retriever_config,
          _record.pii_vocabulary,
          _record.context_window,
          _record.llm_judge_in_the_loop,
          _record.website_prompt_config,
          _record.read_collection_variant,
          _record.write_collection_variant,
          _record.prev_write_collection_variant,
        );
      })(),
    );
  } else {
    return ai_config;
  }
}

export function set_retriever_option(ai_config, option) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        _record.models_config,
        _record.query_config,
        new RetrieverConfig(option),
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_query_alpha(ai_config, alpha) {
  let $ = parse_float(alpha);
  if ($ instanceof Ok) {
    let alpha$1 = $[0];
    return new AiConfig(
      ai_config.org_id,
      (() => {
        let _record = ai_config.config;
        return new Config(
          _record.style_guidelines,
          _record.ai_system,
          _record.llm_config,
          _record.models_config,
          (() => {
            let _record$1 = ai_config.config.query_config;
            return new QueryConfig(
              _record$1.limit,
              alpha$1,
              _record$1.parent_lookup,
              _record$1.hyde,
              _record$1.extract_question,
              _record$1.minimal_score,
              _record$1.split_query,
              _record$1.use_dates,
              _record$1.agentic_retrieval,
            );
          })(),
          _record.retriever_config,
          _record.pii_vocabulary,
          _record.context_window,
          _record.llm_judge_in_the_loop,
          _record.website_prompt_config,
          _record.read_collection_variant,
          _record.write_collection_variant,
          _record.prev_write_collection_variant,
        );
      })(),
    );
  } else {
    return ai_config;
  }
}

export function toggle_agentic_retrieval_config(ai_config) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        _record.models_config,
        (() => {
          let query_config = ai_config.config.query_config;
          let retrieval = ai_config.config.query_config.agentic_retrieval;
          return new QueryConfig(
            query_config.limit,
            query_config.alpha,
            query_config.parent_lookup,
            query_config.hyde,
            query_config.extract_question,
            query_config.minimal_score,
            query_config.split_query,
            query_config.use_dates,
            (() => {
              if (retrieval instanceof Some) {
                return new None();
              } else {
                return new Some(new AgenticRetrievalConfig(5, 10, 3));
              }
            })(),
          );
        })(),
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_agentic_retrieval_max_iterations(ai_config, max_iterations) {
  let $ = $int.parse(max_iterations);
  if ($ instanceof Ok) {
    let max_iterations$1 = $[0];
    return new AiConfig(
      ai_config.org_id,
      (() => {
        let _record = ai_config.config;
        return new Config(
          _record.style_guidelines,
          _record.ai_system,
          _record.llm_config,
          _record.models_config,
          (() => {
            let query_config = ai_config.config.query_config;
            let retrieval = ai_config.config.query_config.agentic_retrieval;
            return new QueryConfig(
              query_config.limit,
              query_config.alpha,
              query_config.parent_lookup,
              query_config.hyde,
              query_config.extract_question,
              query_config.minimal_score,
              query_config.split_query,
              query_config.use_dates,
              $option.map(
                retrieval,
                (agentic_retrieval) => {
                  return new AgenticRetrievalConfig(
                    max_iterations$1,
                    agentic_retrieval.max_docs,
                    agentic_retrieval.max_queries,
                  );
                },
              ),
            );
          })(),
          _record.retriever_config,
          _record.pii_vocabulary,
          _record.context_window,
          _record.llm_judge_in_the_loop,
          _record.website_prompt_config,
          _record.read_collection_variant,
          _record.write_collection_variant,
          _record.prev_write_collection_variant,
        );
      })(),
    );
  } else {
    return ai_config;
  }
}

export function set_agentic_retrieval_max_docs(ai_config, max_docs) {
  let $ = $int.parse(max_docs);
  if ($ instanceof Ok) {
    let max_docs$1 = $[0];
    return new AiConfig(
      ai_config.org_id,
      (() => {
        let _record = ai_config.config;
        return new Config(
          _record.style_guidelines,
          _record.ai_system,
          _record.llm_config,
          _record.models_config,
          (() => {
            let retrieval = ai_config.config.query_config.agentic_retrieval;
            let query_config = ai_config.config.query_config;
            return new QueryConfig(
              query_config.limit,
              query_config.alpha,
              query_config.parent_lookup,
              query_config.hyde,
              query_config.extract_question,
              query_config.minimal_score,
              query_config.split_query,
              query_config.use_dates,
              $option.map(
                retrieval,
                (agentic_retrieval) => {
                  return new AgenticRetrievalConfig(
                    agentic_retrieval.max_iterations,
                    max_docs$1,
                    agentic_retrieval.max_queries,
                  );
                },
              ),
            );
          })(),
          _record.retriever_config,
          _record.pii_vocabulary,
          _record.context_window,
          _record.llm_judge_in_the_loop,
          _record.website_prompt_config,
          _record.read_collection_variant,
          _record.write_collection_variant,
          _record.prev_write_collection_variant,
        );
      })(),
    );
  } else {
    return ai_config;
  }
}

export function set_agentic_retrieval_max_queries(ai_config, max_queries) {
  let $ = $int.parse(max_queries);
  if ($ instanceof Ok) {
    let max_queries$1 = $[0];
    return new AiConfig(
      ai_config.org_id,
      (() => {
        let _record = ai_config.config;
        return new Config(
          _record.style_guidelines,
          _record.ai_system,
          _record.llm_config,
          _record.models_config,
          (() => {
            let query_config = ai_config.config.query_config;
            let retrieval = ai_config.config.query_config.agentic_retrieval;
            return new QueryConfig(
              query_config.limit,
              query_config.alpha,
              query_config.parent_lookup,
              query_config.hyde,
              query_config.extract_question,
              query_config.minimal_score,
              query_config.split_query,
              query_config.use_dates,
              $option.map(
                retrieval,
                (agentic_retrieval) => {
                  return new AgenticRetrievalConfig(
                    agentic_retrieval.max_iterations,
                    agentic_retrieval.max_docs,
                    max_queries$1,
                  );
                },
              ),
            );
          })(),
          _record.retriever_config,
          _record.pii_vocabulary,
          _record.context_window,
          _record.llm_judge_in_the_loop,
          _record.website_prompt_config,
          _record.read_collection_variant,
          _record.write_collection_variant,
          _record.prev_write_collection_variant,
        );
      })(),
    );
  } else {
    return ai_config;
  }
}

export function set_read_collection_variant(ai_config, read_collection_variant) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        _record.models_config,
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_write_collection_variant(
  ai_config,
  write_collection_variant
) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        _record.models_config,
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_prev_write_collection_variant(
  ai_config,
  prev_write_collection_variant
) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        _record.models_config,
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        prev_write_collection_variant,
      );
    })(),
  );
}

export function set_default_model(ai_config, default_model) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let _record$1 = ai_config.config.models_config;
          return new ModelsConfig(
            _record$1.rag,
            _record$1.rag_temperature,
            _record$1.rag_prompt,
            _record$1.rag_modular_config,
            _record$1.rag_structured_call,
            _record$1.run_style_prompt,
            _record$1.convert_markdown_to_html,
            _record$1.reasoning_effort,
            _record$1.verbosity,
            _record$1.compute_score_prompt,
            _record$1.style_2,
            _record$1.summary,
            _record$1.classifier,
            _record$1.translate_model,
            _record$1.conversational_model,
            _record$1.eval_model,
            default_model,
            _record$1.website_scrapping_model,
            _record$1.search_model,
            _record$1.rows_columns_detection_model,
            _record$1.advanced_cell_detection_model,
            _record$1.docx_question_detection_model,
            _record$1.website_capture_model,
            _record$1.answer_instruction_model,
            _record$1.agentic_loop_driver_model,
            _record$1.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_website_scrapping_model(ai_config, website_scrapping_model) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let _record$1 = ai_config.config.models_config;
          return new ModelsConfig(
            _record$1.rag,
            _record$1.rag_temperature,
            _record$1.rag_prompt,
            _record$1.rag_modular_config,
            _record$1.rag_structured_call,
            _record$1.run_style_prompt,
            _record$1.convert_markdown_to_html,
            _record$1.reasoning_effort,
            _record$1.verbosity,
            _record$1.compute_score_prompt,
            _record$1.style_2,
            _record$1.summary,
            _record$1.classifier,
            _record$1.translate_model,
            _record$1.conversational_model,
            _record$1.eval_model,
            _record$1.default_model,
            website_scrapping_model,
            _record$1.search_model,
            _record$1.rows_columns_detection_model,
            _record$1.advanced_cell_detection_model,
            _record$1.docx_question_detection_model,
            _record$1.website_capture_model,
            _record$1.answer_instruction_model,
            _record$1.agentic_loop_driver_model,
            _record$1.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_translate_model(ai_config, translate_model) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let models_config = ai_config.config.models_config;
          return new ModelsConfig(
            models_config.rag,
            models_config.rag_temperature,
            models_config.rag_prompt,
            models_config.rag_modular_config,
            models_config.rag_structured_call,
            models_config.run_style_prompt,
            models_config.convert_markdown_to_html,
            models_config.reasoning_effort,
            models_config.verbosity,
            models_config.compute_score_prompt,
            models_config.style_2,
            models_config.summary,
            models_config.classifier,
            translate_model,
            models_config.conversational_model,
            models_config.eval_model,
            models_config.default_model,
            models_config.website_scrapping_model,
            models_config.search_model,
            models_config.rows_columns_detection_model,
            models_config.advanced_cell_detection_model,
            models_config.docx_question_detection_model,
            models_config.website_capture_model,
            models_config.answer_instruction_model,
            models_config.agentic_loop_driver_model,
            models_config.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_conversational_model(ai_config, conversational_model) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let models_config = ai_config.config.models_config;
          return new ModelsConfig(
            models_config.rag,
            models_config.rag_temperature,
            models_config.rag_prompt,
            models_config.rag_modular_config,
            models_config.rag_structured_call,
            models_config.run_style_prompt,
            models_config.convert_markdown_to_html,
            models_config.reasoning_effort,
            models_config.verbosity,
            models_config.compute_score_prompt,
            models_config.style_2,
            models_config.summary,
            models_config.classifier,
            models_config.translate_model,
            conversational_model,
            models_config.eval_model,
            models_config.default_model,
            models_config.website_scrapping_model,
            models_config.search_model,
            models_config.rows_columns_detection_model,
            models_config.advanced_cell_detection_model,
            models_config.docx_question_detection_model,
            models_config.website_capture_model,
            models_config.answer_instruction_model,
            models_config.agentic_loop_driver_model,
            models_config.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_pii_vocabulary_in_ai_config(ai_config, pii_vocabulary) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        _record.models_config,
        _record.query_config,
        _record.retriever_config,
        pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_rag_structured_call(ai_config, rag_structured_call) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let _record$1 = ai_config.config.models_config;
          return new ModelsConfig(
            _record$1.rag,
            _record$1.rag_temperature,
            _record$1.rag_prompt,
            _record$1.rag_modular_config,
            rag_structured_call,
            _record$1.run_style_prompt,
            _record$1.convert_markdown_to_html,
            _record$1.reasoning_effort,
            _record$1.verbosity,
            _record$1.compute_score_prompt,
            _record$1.style_2,
            _record$1.summary,
            _record$1.classifier,
            _record$1.translate_model,
            _record$1.conversational_model,
            _record$1.eval_model,
            _record$1.default_model,
            _record$1.website_scrapping_model,
            _record$1.search_model,
            _record$1.rows_columns_detection_model,
            _record$1.advanced_cell_detection_model,
            _record$1.docx_question_detection_model,
            _record$1.website_capture_model,
            _record$1.answer_instruction_model,
            _record$1.agentic_loop_driver_model,
            _record$1.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_run_style_prompt(ai_config, run_style_prompt) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let _record$1 = ai_config.config.models_config;
          return new ModelsConfig(
            _record$1.rag,
            _record$1.rag_temperature,
            _record$1.rag_prompt,
            _record$1.rag_modular_config,
            _record$1.rag_structured_call,
            run_style_prompt,
            _record$1.convert_markdown_to_html,
            _record$1.reasoning_effort,
            _record$1.verbosity,
            _record$1.compute_score_prompt,
            _record$1.style_2,
            _record$1.summary,
            _record$1.classifier,
            _record$1.translate_model,
            _record$1.conversational_model,
            _record$1.eval_model,
            _record$1.default_model,
            _record$1.website_scrapping_model,
            _record$1.search_model,
            _record$1.rows_columns_detection_model,
            _record$1.advanced_cell_detection_model,
            _record$1.docx_question_detection_model,
            _record$1.website_capture_model,
            _record$1.answer_instruction_model,
            _record$1.agentic_loop_driver_model,
            _record$1.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_convert_markdown_to_html(
  ai_config,
  convert_markdown_to_html
) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let _record$1 = ai_config.config.models_config;
          return new ModelsConfig(
            _record$1.rag,
            _record$1.rag_temperature,
            _record$1.rag_prompt,
            _record$1.rag_modular_config,
            _record$1.rag_structured_call,
            _record$1.run_style_prompt,
            convert_markdown_to_html,
            _record$1.reasoning_effort,
            _record$1.verbosity,
            _record$1.compute_score_prompt,
            _record$1.style_2,
            _record$1.summary,
            _record$1.classifier,
            _record$1.translate_model,
            _record$1.conversational_model,
            _record$1.eval_model,
            _record$1.default_model,
            _record$1.website_scrapping_model,
            _record$1.search_model,
            _record$1.rows_columns_detection_model,
            _record$1.advanced_cell_detection_model,
            _record$1.docx_question_detection_model,
            _record$1.website_capture_model,
            _record$1.answer_instruction_model,
            _record$1.agentic_loop_driver_model,
            _record$1.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_llm_judge_in_the_loop(ai_config, llm_judge_in_the_loop) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        _record.models_config,
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_reasoning_effort(ai_config, reasoning_effort) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let _record$1 = ai_config.config.models_config;
          return new ModelsConfig(
            _record$1.rag,
            _record$1.rag_temperature,
            _record$1.rag_prompt,
            _record$1.rag_modular_config,
            _record$1.rag_structured_call,
            _record$1.run_style_prompt,
            _record$1.convert_markdown_to_html,
            reasoning_effort,
            _record$1.verbosity,
            _record$1.compute_score_prompt,
            _record$1.style_2,
            _record$1.summary,
            _record$1.classifier,
            _record$1.translate_model,
            _record$1.conversational_model,
            _record$1.eval_model,
            _record$1.default_model,
            _record$1.website_scrapping_model,
            _record$1.search_model,
            _record$1.rows_columns_detection_model,
            _record$1.advanced_cell_detection_model,
            _record$1.docx_question_detection_model,
            _record$1.website_capture_model,
            _record$1.answer_instruction_model,
            _record$1.agentic_loop_driver_model,
            _record$1.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_verbosity(ai_config, verbosity) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let _record$1 = ai_config.config.models_config;
          return new ModelsConfig(
            _record$1.rag,
            _record$1.rag_temperature,
            _record$1.rag_prompt,
            _record$1.rag_modular_config,
            _record$1.rag_structured_call,
            _record$1.run_style_prompt,
            _record$1.convert_markdown_to_html,
            _record$1.reasoning_effort,
            verbosity,
            _record$1.compute_score_prompt,
            _record$1.style_2,
            _record$1.summary,
            _record$1.classifier,
            _record$1.translate_model,
            _record$1.conversational_model,
            _record$1.eval_model,
            _record$1.default_model,
            _record$1.website_scrapping_model,
            _record$1.search_model,
            _record$1.rows_columns_detection_model,
            _record$1.advanced_cell_detection_model,
            _record$1.docx_question_detection_model,
            _record$1.website_capture_model,
            _record$1.answer_instruction_model,
            _record$1.agentic_loop_driver_model,
            _record$1.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_context_window(ai_config, lookback, lookahead) {
  let $ = $int.parse(lookback);
  let $1 = $int.parse(lookahead);
  if ($ instanceof Ok && $1 instanceof Ok) {
    let lookback$1 = $[0];
    let lookahead$1 = $1[0];
    return new AiConfig(
      ai_config.org_id,
      (() => {
        let _record = ai_config.config;
        return new Config(
          _record.style_guidelines,
          _record.ai_system,
          _record.llm_config,
          _record.models_config,
          _record.query_config,
          _record.retriever_config,
          _record.pii_vocabulary,
          new ContextWindow(lookback$1, lookahead$1),
          _record.llm_judge_in_the_loop,
          _record.website_prompt_config,
          _record.read_collection_variant,
          _record.write_collection_variant,
          _record.prev_write_collection_variant,
        );
      })(),
    );
  } else {
    return ai_config;
  }
}

export function toggle_rag_modular_config(ai_config) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let models_config = ai_config.config.models_config;
          let _block;
          let $ = models_config.rag_modular_config;
          if ($ instanceof Some) {
            _block = new None();
          } else {
            _block = new Some(default_rag_modular_config());
          }
          let rag_modular_config = _block;
          return new ModelsConfig(
            models_config.rag,
            models_config.rag_temperature,
            models_config.rag_prompt,
            rag_modular_config,
            models_config.rag_structured_call,
            models_config.run_style_prompt,
            models_config.convert_markdown_to_html,
            models_config.reasoning_effort,
            models_config.verbosity,
            models_config.compute_score_prompt,
            models_config.style_2,
            models_config.summary,
            models_config.classifier,
            models_config.translate_model,
            models_config.conversational_model,
            models_config.eval_model,
            models_config.default_model,
            models_config.website_scrapping_model,
            models_config.search_model,
            models_config.rows_columns_detection_model,
            models_config.advanced_cell_detection_model,
            models_config.docx_question_detection_model,
            models_config.website_capture_model,
            models_config.answer_instruction_model,
            models_config.agentic_loop_driver_model,
            models_config.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

function update_rag_modular_config(ai_config, updater) {
  return new AiConfig(
    ai_config.org_id,
    (() => {
      let _record = ai_config.config;
      return new Config(
        _record.style_guidelines,
        _record.ai_system,
        _record.llm_config,
        (() => {
          let models_config = ai_config.config.models_config;
          let rag_modular_config = $option.map(
            models_config.rag_modular_config,
            updater,
          );
          return new ModelsConfig(
            models_config.rag,
            models_config.rag_temperature,
            models_config.rag_prompt,
            rag_modular_config,
            models_config.rag_structured_call,
            models_config.run_style_prompt,
            models_config.convert_markdown_to_html,
            models_config.reasoning_effort,
            models_config.verbosity,
            models_config.compute_score_prompt,
            models_config.style_2,
            models_config.summary,
            models_config.classifier,
            models_config.translate_model,
            models_config.conversational_model,
            models_config.eval_model,
            models_config.default_model,
            models_config.website_scrapping_model,
            models_config.search_model,
            models_config.rows_columns_detection_model,
            models_config.advanced_cell_detection_model,
            models_config.docx_question_detection_model,
            models_config.website_capture_model,
            models_config.answer_instruction_model,
            models_config.agentic_loop_driver_model,
            models_config.default_fallback_models,
          );
        })(),
        _record.query_config,
        _record.retriever_config,
        _record.pii_vocabulary,
        _record.context_window,
        _record.llm_judge_in_the_loop,
        _record.website_prompt_config,
        _record.read_collection_variant,
        _record.write_collection_variant,
        _record.prev_write_collection_variant,
      );
    })(),
  );
}

export function set_rag_modular_role(ai_config, role) {
  return update_rag_modular_config(
    ai_config,
    (c) => {
      return new RagModularConfig(
        role,
        c.entity_mismatch,
        c.approach,
        c.tone_voice,
        c.tone_style,
        c.repeat_or_not_question,
        c.formatting,
        c.length,
        c.evidence_over_assertion,
        c.redirect,
        c.what_to_return,
      );
    },
  );
}

export function set_rag_modular_entity_mismatch(ai_config, entity_mismatch) {
  return update_rag_modular_config(
    ai_config,
    (c) => {
      return new RagModularConfig(
        c.role,
        entity_mismatch,
        c.approach,
        c.tone_voice,
        c.tone_style,
        c.repeat_or_not_question,
        c.formatting,
        c.length,
        c.evidence_over_assertion,
        c.redirect,
        c.what_to_return,
      );
    },
  );
}

export function set_rag_modular_approach(ai_config, approach) {
  return update_rag_modular_config(
    ai_config,
    (c) => {
      return new RagModularConfig(
        c.role,
        c.entity_mismatch,
        approach,
        c.tone_voice,
        c.tone_style,
        c.repeat_or_not_question,
        c.formatting,
        c.length,
        c.evidence_over_assertion,
        c.redirect,
        c.what_to_return,
      );
    },
  );
}

export function set_rag_modular_tone_voice(ai_config, tone_voice) {
  return update_rag_modular_config(
    ai_config,
    (c) => {
      return new RagModularConfig(
        c.role,
        c.entity_mismatch,
        c.approach,
        tone_voice,
        c.tone_style,
        c.repeat_or_not_question,
        c.formatting,
        c.length,
        c.evidence_over_assertion,
        c.redirect,
        c.what_to_return,
      );
    },
  );
}

export function set_rag_modular_tone_style(ai_config, tone_style) {
  return update_rag_modular_config(
    ai_config,
    (c) => {
      return new RagModularConfig(
        c.role,
        c.entity_mismatch,
        c.approach,
        c.tone_voice,
        tone_style,
        c.repeat_or_not_question,
        c.formatting,
        c.length,
        c.evidence_over_assertion,
        c.redirect,
        c.what_to_return,
      );
    },
  );
}

export function set_rag_modular_repeat_question(
  ai_config,
  repeat_or_not_question
) {
  return update_rag_modular_config(
    ai_config,
    (c) => {
      return new RagModularConfig(
        c.role,
        c.entity_mismatch,
        c.approach,
        c.tone_voice,
        c.tone_style,
        repeat_or_not_question,
        c.formatting,
        c.length,
        c.evidence_over_assertion,
        c.redirect,
        c.what_to_return,
      );
    },
  );
}

export function set_rag_modular_formatting(ai_config, formatting) {
  return update_rag_modular_config(
    ai_config,
    (c) => {
      return new RagModularConfig(
        c.role,
        c.entity_mismatch,
        c.approach,
        c.tone_voice,
        c.tone_style,
        c.repeat_or_not_question,
        formatting,
        c.length,
        c.evidence_over_assertion,
        c.redirect,
        c.what_to_return,
      );
    },
  );
}

export function set_rag_modular_length(ai_config, length) {
  return update_rag_modular_config(
    ai_config,
    (c) => {
      return new RagModularConfig(
        c.role,
        c.entity_mismatch,
        c.approach,
        c.tone_voice,
        c.tone_style,
        c.repeat_or_not_question,
        c.formatting,
        length,
        c.evidence_over_assertion,
        c.redirect,
        c.what_to_return,
      );
    },
  );
}

export function set_rag_modular_evidence_over_assertion(
  ai_config,
  evidence_over_assertion
) {
  return update_rag_modular_config(
    ai_config,
    (c) => {
      return new RagModularConfig(
        c.role,
        c.entity_mismatch,
        c.approach,
        c.tone_voice,
        c.tone_style,
        c.repeat_or_not_question,
        c.formatting,
        c.length,
        evidence_over_assertion,
        c.redirect,
        c.what_to_return,
      );
    },
  );
}

export function set_rag_modular_redirect(ai_config, redirect) {
  return update_rag_modular_config(
    ai_config,
    (c) => {
      return new RagModularConfig(
        c.role,
        c.entity_mismatch,
        c.approach,
        c.tone_voice,
        c.tone_style,
        c.repeat_or_not_question,
        c.formatting,
        c.length,
        c.evidence_over_assertion,
        redirect,
        c.what_to_return,
      );
    },
  );
}

export function set_rag_modular_what_to_return(ai_config, what_to_return) {
  return update_rag_modular_config(
    ai_config,
    (c) => {
      return new RagModularConfig(
        c.role,
        c.entity_mismatch,
        c.approach,
        c.tone_voice,
        c.tone_style,
        c.repeat_or_not_question,
        c.formatting,
        c.length,
        c.evidence_over_assertion,
        c.redirect,
        what_to_return,
      );
    },
  );
}
